import React, { useState, useMemo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { apiCall } from "../../../utils/axiosService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiResponse } from "../../../utils/apiResponse";
import moment from "moment";
import Loader from "../../Loader/Loader";
import { Button, Table, OverlayTrigger, Popover } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import Select from "react-select";
import { commonService } from "../../../utils/commonService";
import ticket from "../../../Assets/Images/Revenue-management/tableTicket.svg";
import EventViewModal from "../../CommonComponent/EventViewModal";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const MONTHS_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const DOW_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const SEASON_DEFAULT = [
  0.72, 0.74, 0.88, 0.95, 1.05, 1.12, 1.15, 1.1, 0.98, 0.9, 0.8, 0.85,
];
const ADR_SEASON_DEFAULT = [
  0.88, 0.9, 0.95, 1.0, 1.05, 1.12, 1.14, 1.1, 1.03, 0.97, 0.9, 0.94,
];

const fmtNum = (n, dec = 0) => {
  if (isNaN(n) || n === null || n === undefined) return "—";
  return Number(n).toLocaleString("en-US", {
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  });
};
const fmtPct = (n) => {
  return fmtNum(n, 1) + "%";
};

const BudgetSimulator = ({ api, para, setting }) => {
  // Navigation & View State
  const curentYear = new Date().getFullYear();
  const curentMonth = new Date().getMonth();
  const [year, setYear] = useState(curentYear);
  const [viewMode, setViewMode] = useState("rooms");
  const [segFilter, setSegFilter] = useState("all");
  const [activeMonth, setActiveMonth] = useState(curentMonth);
  const [isDatewiseLoading, setIsDatewiseLoading] = useState(false);
  const [isDatewise, setIsDatewise] = useState(true);
  const [showLY, setShowLY] = useState(false);
  const [activeMainTab, setActiveMainTab] = useState("breakdown");

  // Hidden segments for legends toggle
  const [hiddenSegments, setHiddenSegments] = useState({});
  const [hiddenSegments2, setHiddenSegments2] = useState({});
  const toggleSegment = (key) => {
    setHiddenSegments((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const toggleSegment2 = (key) => {
    setHiddenSegments2((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const eventListRef = useRef([]);
  const selectedEventDateRef = useRef(null);
  const eventListPropsRef = useRef([]);
  const [showTicketModal, setShowTicketModal] = useState(false);

  const closeTicketModal = () => {
    setShowTicketModal(false);
  };

  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail,
  );

  const propertyCode = para?.propertyCode || para?.PropertyCode || para?.propertycode || propertyDetailFromRTK?.propertycode || "";
  const propertyId = para?.propertyId || para?.PropertyId || para?.propertyid || propertyDetailFromRTK?.propertyid || 0;

  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate,
  );
  const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);

  const currencySign = useMemo(
    () => propertyDetailFromRTK?.currency_term || "$",
    [propertyDetailFromRTK],
  );

  const getEventList = async () => {
    if (api === 0) return;
    let eventList = await apiCall(
      {
        method: "POST",
        url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
        body: {
          pageNum: 1,
          pageSize: 10,
          sortColumn: "",
          sortDirection: "asc",
          searchValue: "",
          propertyid: parseInt(propertyId),
          startdate: null,
          enddate: null,
          eventname: "",
          eventtypeterm: "",
          yearterm: ``,
        },
      },
      false,
    );

    let eventListResponse = apiResponse(false, eventList);

    if (eventListResponse?.isValidate) {
      let eventListArr = [];
      eventListResponse?.data?.data?.forEach((item) => {
        try {
          let singleEventObj = {
            id: item?.eventid ? item?.eventid : 0,
            name: item?.eventname,
            detail: item?.eventdetails,
            startDate: item?.startdate,
            endDate: item?.enddate,
            eventJson: item?.eventjson,
            eventResourceId: item?.eventsourceid,
          };
          let eventJsonData = "";
          if (item?.eventjson) {
            var decodedString = decodeURIComponent(item?.eventjson);
            const jsonStringWithoutQuotes = decodedString.slice(1, -1);
            const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
            eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
            let desc = eventJsonData?.description?.replaceAll("+", " ");
            singleEventObj = {
              ...singleEventObj,
              labels: eventJsonData?.labels ? eventJsonData?.labels : "",
              rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
              local_rank: eventJsonData?.local_rank
                ? eventJsonData?.local_rank
                : 0,
              phq_attendance: eventJsonData?.phq_attendance
                ? eventJsonData?.phq_attendance
                : 0,
              geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
              geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
              detail: desc,
            };
          }
          eventListArr.push(singleEventObj);
        } catch (err) {}
      });
      eventListRef.current = eventListArr;
    }

    if (!eventListResponse?.isValidate) {
      eventListRef.current = [];
    }
  };

  useEffect(() => {
    if (api === 0) return;
    if (propertyId) {
      getEventList();
    }
  }, [propertyId, api]);

  // Last Year actuals state & API fetch
  const [apiLyData, setApiLyData] = useState([]);
  const [apiLyLoading, setApiLyLoading] = useState(false);
  const [selectedYears, setSelectedYears] = useState([]);

  const fetchLyData = async (years, isChecked) => {
    if (api === 0) return setApiLyLoading(false);
    if (!propertyCode) return setApiLyLoading(false);
    if (!asOfDateFromRTK && !defaultAsOfDateFromRTK)
      return setApiLyLoading(false);

    // setApiLyLoading(true);
    try {
      const yearsToFetch =
        years && years.length > 0 ? years.map((y) => y.value) : [year];

      let _URL = "";
      if (isChecked) {
        _URL =
          API_URL.BASE_API_URL.SnapShot + API_URL.REV_PAK_90_DAY_OUTLOOK.GET_LY;
      } else {
        _URL =
          API_URL.BASE_API_URL.SnapShot +
          API_URL.REV_PAK_90_DAY_OUTLOOK.GET_LY_DATEWISE;
      }

      const promises = yearsToFetch.map(async (y) => {
        const tzStart = commonService.convertDateInTimezone(
          new Date(y + 1, 0, 1),
        );
        const tzEnd = commonService.convertDateInTimezone(
          new Date(y + 1, 11, 31),
        );
        const startDatePayload = commonService.getDateForNode(tzStart);
        const endDatePayload = commonService.getDateForNode(tzEnd);

        let lyDataResponse = await apiCall(
          {
            method: "POST",
            url: _URL,
            body: {
              AsOfDate: asOfDateFromRTK || defaultAsOfDateFromRTK || "",
              startDate: startDatePayload,
              endDate: endDatePayload,
              propertyCode: propertyCode,
            },
          },
          false,
        );

        let response = apiResponse(false, lyDataResponse);
        if (response?.isValidate && response?.data?.data) {
          return response.data.data;
        }
        return [];
      });

      const results = await Promise.all(promises);
      const mergedData = results.flat();

      setApiLyData(mergedData);
    } catch (err) {
      
      setApiLyData([]);
    } finally {
      setApiLyLoading(false);
    }
  };

  useEffect(() => {
    // fetchLyData();
  }, [year, propertyCode, asOfDateFromRTK, defaultAsOfDateFromRTK, api]);

  // Budget Save actuals state & handler
  const [saveLoading, setSaveLoading] = useState(false);

  const handleSave = async () => {
    if (api === 0) return;
    if (!propertyId) return;
    setSaveLoading(true);

    const updatedArray = [];
    const updatedTotalArray = [];

    activeMonthRows.forEach((r) => {
      const dayDate = new Date(year, activeMonth, r.day);
      const dbDate = commonService.getDateInDBFormat(dayDate);

      segments.forEach((seg) => {
        updatedArray.push({
          propertyid: parseInt(propertyId),
          marketsegment_term: seg.label,
          budgetdate: dbDate,
          actualoccupency: r.paidRooms || 0,
          actualrevenue: r.rev || 0,
          occupency: r.segs[seg.key]?.rooms || 0,
          revenue: r.segs[seg.key]?.rev || 0,
          occupencydifference: 0,
          revenuedifference: 0,
        });
      });
    });

    segments.forEach((seg) => {
      let totalActualOcc = 0;
      let totalActualRev = 0;
      let totalOcc = 0;
      let totalRev = 0;

      activeMonthRows.forEach((r) => {
        totalActualOcc += r.paidRooms || 0;
        totalActualRev += r.rev || 0;
        totalOcc += r.segs[seg.key]?.rooms || 0;
        totalRev += r.segs[seg.key]?.rev || 0;
      });

      updatedTotalArray.push({
        propertyid: parseInt(propertyId),
        marketsegment_term: seg.label,
        actualoccupency: totalActualOcc,
        actualrevenue: totalActualRev,
        occupency: totalOcc,
        revenue: totalRev,
        occupencydifference: 0,
        revenuedifference: 0,
      });
    });

    const payload = {
      propertyid: parseInt(propertyId),
      budgetyear: year.toString(),
      month_term: (activeMonth + 1).toString(),
      BudgetData: updatedArray,
      BudgetTotal: updatedTotalArray,
    };

    try {
      const saveResponse = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.RevenueManagement +
            API_URL.REVENUE_BUDGET.SAVEBYDATEWITHTOTAL,
          body: payload,
        },
        true,
      );

      apiResponse(true, saveResponse, setSaveLoading);
    } catch (err) {
      
    } finally {
      setSaveLoading(false);
    }
  };

  const fmtDollar = (n, dec = 0) => {
    if (isNaN(n) || n === null || n === undefined) return "—";
    if (dec === 0) {
      return commonService.formateAmount(n, currencySign);
    }
    return currencySign + fmtNum(n, dec);
  };

  const [segments, setSegments] = useState([]);
  const [segOptions, setSegOptions] = useState([
    { label: "All Segments", value: "all" },
  ]);

  const getMarketSegmentData = async () => {
    if (api === 0) return;
    if (!propertyId) return;
    try {
      let marketSegmentDataResponse = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.Configuration +
            API_URL.PROJECT_TERM.GET_LIST_BY_MULTIPLE_CATEGORY_AND_PROPERTY,
          body: {
            categorynamebycomma: "Market Segment",
            propertyid: parseInt(propertyId),
          },
        },
        false,
      );

      let response = apiResponse(false, marketSegmentDataResponse);

      if (response?.isValidate && response?.data?.data) {
        const loadedSegs = response.data.data.map((item, index) => {
          const term = item.term;
          const lower = term.toLowerCase();
          let key = lower.replace(/[^a-z0-9]/g, "");
          if (!key) key = `seg${index}`;

          let category = "other";
          if (lower.includes("corp")) category = "corp";
          else if (
            lower.includes("leisure") ||
            lower.includes("transient") ||
            lower.includes("lei")
          )
            category = "lei";
          else if (
            lower.includes("group") ||
            lower.includes("meeting") ||
            lower.includes("grp")
          )
            category = "grp";
          else if (lower.includes("gov") || lower.includes("state"))
            category = "gov";
          else if (lower.includes("ota") || lower.includes("online"))
            category = "ota";

          const defaultColor = commonService.getColorByCategory(key);
          // DEFAULT_COLORS[index % DEFAULT_COLORS.length] || DEFAULT_COLORS[0];
          return {
            key,
            label: term,
            category,
            color: defaultColor.color,
            light: defaultColor.light,
          };
        });

        if (loadedSegs.length > 0) {
          setSegments(loadedSegs);
          const lst = [
            { label: "All Segments", value: "all" },
            ...loadedSegs.map((s) => ({ label: s.label, value: s.key })),
          ];
          setSegOptions(lst);
          setSegFilter("all");

          const baseMixPreset = {
            corp: 28,
            lei: 22,
            grp: 20,
            gov: 10,
            ota: 14,
            other: 6,
          };
          const initialMix = {};
          loadedSegs.forEach((seg) => {
            const sameCatSegs = loadedSegs.filter(
              (x) => x.category === seg.category,
            );
            const presetVal =
              baseMixPreset[seg.category] || baseMixPreset["other"] || 0;
            initialMix[seg.key] = Number(
              (presetVal / sameCatSegs.length).toFixed(1),
            );
          });
          setMix(initialMix);
        }
      }
    } catch (err) {
      
    }
  };

  useEffect(() => {
    if (api === 0) return;
    setCapacity(propertyDetailFromRTK?.revenuconfig?.[0]?.totalrooms || 10);
    if (propertyId) {
      getMarketSegmentData();
    }
  }, [propertyId, propertyDetailFromRTK, api]);

  // Configuration Inputs
  const [capacity, setCapacity] = useState(
    propertyDetailFromRTK?.revenuconfig?.[0]?.totalrooms || 10,
  );
  const [baseADR, setBaseADR] = useState(139);
  const [adrGrowth, setAdrGrowth] = useState(3.5);
  const [corpDisc, setCorpDisc] = useState(88);
  const [grpDisc, setGrpDisc] = useState(82);
  const [govtRate, setGovtRate] = useState(136);
  const [wkndPct, setWkndPct] = useState(12);

  const [occTarget, setOccTarget] = useState(72);
  const [demandGrowth, setDemandGrowth] = useState(2.0);
  const [maxSell, setMaxSell] = useState(97);
  const [oooRooms, setOooRooms] = useState(3);
  const [compRooms, setCompRooms] = useState(1);
  const [grpBlock, setGrpBlock] = useState(20);
  const [grpWash, setGrpWash] = useState(18);

  const [fnbPerRoom, setFnbPerRoom] = useState(18);
  const [mtgRevPerRoom, setMtgRevPerRoom] = useState(8);
  const [otherRev, setOtherRev] = useState(5);

  const [otaComm, setOtaComm] = useState(18);
  const [channel, setChannel] = useState(2.5);
  const [franchise, setFranchise] = useState(5.5);
  const [loyalty, setLoyalty] = useState(4.0);
  const [taxRate, setTaxRate] = useState(14.5);

  const [mix, setMix] = useState({
    corp: 28,
    lei: 22,
    grp: 20,
    gov: 10,
    ota: 14,
    other: 6,
  });

  const [occSeason, setOccSeason] = useState([...SEASON_DEFAULT]);
  const [adrSeason, setAdrSeason] = useState([...ADR_SEASON_DEFAULT]);

  const handleMixChange = (key, val) => {
    setMix((prev) => ({
      ...prev,
      [key]: parseFloat(val) || 0,
    }));
  };

  const handleOccSeasonChange = (idx, val) => {
    setOccSeason((prev) => {
      const copy = [...prev];
      copy[idx] = parseFloat(val) || 0;
      return copy;
    });
  };

  const handleAdrSeasonChange = (idx, val) => {
    setAdrSeason((prev) => {
      const copy = [...prev];
      copy[idx] = parseFloat(val) || 0;
      return copy;
    });
  };

  const resetSeasonality = () => {
    if (api === 0) return;
    setOccSeason([...SEASON_DEFAULT]);
    setAdrSeason([...ADR_SEASON_DEFAULT]);
  };

  const applyScenario = (type) => {
    const scenarios = {
      conservative: {
        baseADR: 119,
        occTarget: 62,
        adrGrowth: 1.5,
        wkndPct: 8,
        mixPreset: { corp: 25, lei: 20, grp: 22, gov: 12, ota: 14, other: 7 },
      },
      base: {
        baseADR: 139,
        occTarget: 72,
        adrGrowth: 3.5,
        wkndPct: 12,
        mixPreset: { corp: 28, lei: 22, grp: 20, gov: 10, ota: 14, other: 6 },
      },
      aggressive: {
        baseADR: 159,
        occTarget: 81,
        adrGrowth: 5.5,
        wkndPct: 18,
        mixPreset: { corp: 32, lei: 24, grp: 18, gov: 8, ota: 12, other: 6 },
      },
    };
    const s = scenarios[type];
    if (!s) return;
    setBaseADR(s.baseADR);
    setOccTarget(s.occTarget);
    setAdrGrowth(s.adrGrowth);
    setWkndPct(s.wkndPct);

    const newMix = {};
    segments.forEach((seg) => {
      const sameCatSegs = segments.filter((x) => x.category === seg.category);
      const presetVal = s.mixPreset[seg.category] || s.mixPreset["other"] || 0;
      newMix[seg.key] = Number((presetVal / sameCatSegs.length).toFixed(1));
    });
    setMix(newMix);
  };

  // Calculation Engine
  const generateDayData = (yearVal, monthVal, inputs) => {
    const days = new Date(yearVal, monthVal + 1, 0).getDate();
    const seasonOcc = inputs.occSeason[monthVal];
    const seasonADR = inputs.adrSeason[monthVal];

    const available = Math.max(0, inputs.capacity - inputs.oooRooms);
    const sellable = Math.max(0, available - inputs.compRooms);

    const barBase =
      inputs.baseADR *
      (1 + inputs.adrGrowth / 100) *
      (1 + inputs.demandGrowth / 100) *
      seasonADR;

    const totalMix = Object.values(inputs.mix).reduce((a, b) => a + b, 0);
    const normMix = {};
    (inputs.segments || []).forEach((s) => {
      normMix[s.key] = (inputs.mix[s.key] || 0) / (totalMix || 100);
    });

    const grpSeg = (inputs.segments || []).find((s) => s.category === "grp");
    const grpKey = grpSeg ? grpSeg.key : null;

    const corpSeg =
      (inputs.segments || []).find((s) => s.category === "corp") ||
      (inputs.segments || [])[0];
    const corpKey = corpSeg ? corpSeg.key : null;

    const rows = [];
    for (let d = 1; d <= days; d++) {
      const dow = new Date(yearVal, monthVal, d).getDay();
      const wknd = dow === 0 || dow === 6;
      const wkndBoost = wknd ? 1 + inputs.wkndPct / 100 : 1.0;
      const noise =
        1 + (((((yearVal * 100 + monthVal) * 31 + d) * 17) % 13) - 6) * 0.008;

      const occRaw = Math.min(
        inputs.maxSell / 100,
        (inputs.occTarget / 100) * seasonOcc * wkndBoost * noise,
      );
      const paidRooms = Math.round(sellable * occRaw);
      const compNight = inputs.compRooms;
      const totalOcc = paidRooms + compNight;
      const realOccPct = (totalOcc / inputs.capacity) * 100;

      const bar = barBase * wkndBoost;

      const segADRMap = {};
      (inputs.segments || []).forEach((s) => {
        if (s.category === "corp") {
          segADRMap[s.key] = bar * (inputs.corpDisc / 100);
        } else if (s.category === "lei") {
          segADRMap[s.key] = bar * 1.0;
        } else if (s.category === "grp") {
          segADRMap[s.key] = bar * (inputs.grpDisc / 100);
        } else if (s.category === "gov") {
          segADRMap[s.key] =
            inputs.govtRate *
            (1 + inputs.adrGrowth / 100) *
            (1 + inputs.demandGrowth / 100);
        } else if (s.category === "ota") {
          segADRMap[s.key] = bar * 0.96;
        } else {
          segADRMap[s.key] = bar * 0.91;
        }
      });

      const grpBlocked = Math.round(sellable * (inputs.grpBlock / 100));
      const grpPickup = Math.round(grpBlocked * (1 - inputs.grpWash / 100));

      const segData = {};
      let nonGrpRooms = paidRooms;

      if (grpKey) {
        const grpActual = Math.min(
          grpPickup,
          Math.round(paidRooms * normMix[grpKey]),
        );
        segData[grpKey] = {
          rooms: grpActual,
          adr: segADRMap[grpKey],
          rev: grpActual * segADRMap[grpKey],
        };
        nonGrpRooms = paidRooms - grpActual;
      }

      const nonGrpKeys = (inputs.segments || [])
        .map((s) => s.key)
        .filter((k) => k !== grpKey);
      const nonGrpMixSum = nonGrpKeys.reduce(
        (a, k) => a + (inputs.mix[k] || 0),
        0,
      );
      nonGrpKeys.forEach((k) => {
        const share =
          nonGrpMixSum > 0 ? (inputs.mix[k] || 0) / nonGrpMixSum : 0;
        const rooms = Math.round(nonGrpRooms * share);
        segData[k] = { rooms, adr: segADRMap[k], rev: rooms * segADRMap[k] };
      });

      const allocated = (inputs.segments || []).reduce(
        (a, s) => a + (segData[s.key]?.rooms || 0),
        0,
      );
      const diff = paidRooms - allocated;
      if (diff !== 0) {
        let targetKey = null;
        for (let i = nonGrpKeys.length - 1; i >= 0; i--) {
          const k = nonGrpKeys[i];
          if ((inputs.mix[k] || 0) > 0) {
            targetKey = k;
            break;
          }
        }
        // We no longer force the diff into the last segment if all mixes are 0.
        // If all non-group mixes are 0, the unallocated rooms will simply remain unallocated to any segment.

        if (targetKey && segData[targetKey]) {
          segData[targetKey].rooms += diff;
          segData[targetKey].rev =
            segData[targetKey].rooms * segData[targetKey].adr;
        }
      }

      const roomRev = (inputs.segments || []).reduce(
        (a, s) => a + (segData[s.key]?.rev || 0),
        0,
      );
      const blendedADR = paidRooms > 0 ? roomRev / paidRooms : 0;
      const revPAR = roomRev / inputs.capacity;

      let otaCommAmt = 0;
      (inputs.segments || []).forEach((s) => {
        if (s.category === "ota" && segData[s.key]) {
          otaCommAmt += segData[s.key].rev * (inputs.otaComm / 100);
        }
      });

      const gdsFee = roomRev * (inputs.channel / 100);
      const franchiseFee = roomRev * (inputs.franchise / 100);
      const loyaltyFee = roomRev * (inputs.loyalty / 100);
      const totalDistCost = otaCommAmt + gdsFee + franchiseFee + loyaltyFee;
      const netRoomRev = roomRev - totalDistCost;

      const fnbRev = totalOcc * inputs.fnbPerRoom;
      const mtgRooms = grpKey && segData[grpKey] ? segData[grpKey].rooms : 0;
      const mtgRev = mtgRooms * inputs.mtgRevPerRoom;
      const otherRevAmt = totalOcc * inputs.otherRev;
      const totalAncillary = fnbRev + mtgRev + otherRevAmt;

      const totalRev = netRoomRev + totalAncillary;
      const taxAmt = roomRev * (inputs.taxRate / 100);

      rows.push({
        day: d,
        dow,
        wknd,
        occ: realOccPct,
        rooms: totalOcc,
        paidRooms,
        compNight,
        rev: roomRev,
        adr: blendedADR,
        revPAR,
        segs: segData,
        grpBlocked,
        grpPickup,
        otaCommAmt,
        gdsFee,
        franchiseFee,
        loyaltyFee,
        totalDistCost,
        netRoomRev,
        fnbRev,
        mtgRev,
        otherRevAmt,
        totalAncillary,
        totalRev,
        taxAmt,
      });
    }
    return rows;
  };

  const inputs = useMemo(
    () => ({
      capacity,
      baseADR,
      adrGrowth,
      corpDisc,
      grpDisc,
      govtRate,
      wkndPct,
      occTarget,
      demandGrowth,
      maxSell,
      oooRooms,
      compRooms,
      grpBlock,
      grpWash,
      fnbPerRoom,
      mtgRevPerRoom,
      otherRev,
      otaComm,
      channel,
      franchise,
      loyalty,
      taxRate,
      mix,
      occSeason,
      adrSeason,
      segments,
    }),
    [
      capacity,
      baseADR,
      adrGrowth,
      corpDisc,
      grpDisc,
      govtRate,
      wkndPct,
      occTarget,
      demandGrowth,
      maxSell,
      oooRooms,
      compRooms,
      grpBlock,
      grpWash,
      fnbPerRoom,
      mtgRevPerRoom,
      otherRev,
      otaComm,
      channel,
      franchise,
      loyalty,
      taxRate,
      mix,
      occSeason,
      adrSeason,
      segments,
    ],
  );

  const [segmentOverrides, setSegmentOverrides] = useState({});
  const [dayOverrides, setDayOverrides] = useState({});
  const [totalOverrides, setTotalOverrides] = useState({});

  const handleTotalEdit = (monthIdx, field, value) => {
    setTotalOverrides((prev) => {
      const monthData = prev[monthIdx] || {};
      const val = value === "" ? "" : Number(value);
      return {
        ...prev,
        [monthIdx]: {
          ...monthData,
          [field]: val,
        },
      };
    });
  };

  const handleDayEdit = (monthIdx, day, field, value) => {
    setDayOverrides((prev) => {
      const monthData = prev[monthIdx] || {};
      const dayData = monthData[day] || {};
      const val = value === "" ? "" : Number(value);
      const newDayData = { ...dayData, [field]: val };

      return {
        ...prev,
        [monthIdx]: {
          ...monthData,
          [day]: newDayData,
        },
      };
    });

    setTotalOverrides((prev) => {
      const monthData = prev[monthIdx];
      if (!monthData) return prev;
      const newMonthData = { ...monthData };
      if (field === "paidRooms" && newMonthData.paidRooms !== undefined)
        delete newMonthData.paidRooms;
      if (field === "occ" && newMonthData.occ !== undefined)
        delete newMonthData.occ;
      if (field === "rev" && newMonthData.rev !== undefined)
        delete newMonthData.rev;
      if (field === "adr" && newMonthData.adr !== undefined)
        delete newMonthData.adr;
      return { ...prev, [monthIdx]: newMonthData };
    });
  };

  const handleSegmentEdit = (monthIdx, day, segKey, field, value) => {
    setSegmentOverrides((prev) => {
      const monthData = prev[monthIdx] || {};
      const dayData = monthData[day] || {};
      const segData = dayData[segKey] || {};

      const val = value === "" ? "" : Number(value);
      const newSegData = { ...segData, [field]: val };

      if (field === "rooms" && segData.adr !== undefined && val !== "") {
        newSegData.rev = val * segData.adr;
      } else if (field === "adr" && segData.rooms !== undefined && val !== "") {
        newSegData.rev = val * segData.rooms;
      }

      return {
        ...prev,
        [monthIdx]: {
          ...monthData,
          [day]: {
            ...dayData,
            [segKey]: newSegData,
          },
        },
      };
    });

    setTotalOverrides((prev) => {
      const monthData = prev[monthIdx];
      if (!monthData) return prev;
      const newMonthData = { ...monthData };

      const fieldRooms = `seg_${segKey}_rooms`;
      const fieldRev = `seg_${segKey}_rev`;
      const fieldAdr = `seg_${segKey}_adr`;

      if (field === "rooms") {
        delete newMonthData[fieldRooms];
        delete newMonthData[fieldRev];
      } else if (field === "adr") {
        delete newMonthData[fieldAdr];
        delete newMonthData[fieldRev];
      } else if (field === "rev") {
        delete newMonthData[fieldRev];
        delete newMonthData[fieldAdr];
      }

      return { ...prev, [monthIdx]: newMonthData };
    });
  };

  const allData = useMemo(() => {
    const list = [];
    for (let m = 0; m < 12; m++) {
      const days = generateDayData(year, m, inputs);

      days.forEach((dayData) => {
        const d = dayData.day;
        if (segmentOverrides[m] && segmentOverrides[m][d]) {
          const overridesForDay = segmentOverrides[m][d];
          let totalSegRev = 0;
          let totalSegRooms = 0;

          Object.keys(dayData.segs).forEach((segKey) => {
            if (overridesForDay[segKey]) {
              const override = overridesForDay[segKey];
              if (override.rooms !== undefined)
                dayData.segs[segKey].rooms = override.rooms;
              if (override.adr !== undefined)
                dayData.segs[segKey].adr = override.adr;
              if (override.rev !== undefined)
                dayData.segs[segKey].rev = override.rev;
            }
            totalSegRev += Number(dayData.segs[segKey].rev) || 0;
            totalSegRooms += Number(dayData.segs[segKey].rooms) || 0;
          });

          const blendedADR =
            totalSegRooms > 0 ? totalSegRev / totalSegRooms : 0;
          dayData.paidRooms = totalSegRooms;
          dayData.rooms = totalSegRooms + dayData.compNight;
          dayData.occ =
            inputs.capacity > 0 ? (dayData.rooms / inputs.capacity) * 100 : 0;
          dayData.rev = totalSegRev;
          dayData.adr = blendedADR;
          dayData.revPAR = (dayData.occ * blendedADR) / 100;

          let otaCommAmt = 0;
          (inputs.segments || []).forEach((s) => {
            if (s.category === "ota" && dayData.segs[s.key]) {
              otaCommAmt +=
                (Number(dayData.segs[s.key].rev) || 0) * (inputs.otaComm / 100);
            }
          });

          const gdsFee = totalSegRev * (inputs.channel / 100);
          const franchiseFee = totalSegRev * (inputs.franchise / 100);
          const loyaltyFee = totalSegRev * (inputs.loyalty / 100);
          const totalDistCost = otaCommAmt + gdsFee + franchiseFee + loyaltyFee;
          const netRoomRev = totalSegRev - totalDistCost;

          dayData.otaCommAmt = otaCommAmt;
          dayData.gdsFee = gdsFee;
          dayData.franchiseFee = franchiseFee;
          dayData.loyaltyFee = loyaltyFee;
          dayData.totalDistCost = totalDistCost;
          dayData.netRoomRev = netRoomRev;

          dayData.fnbRev = dayData.rooms * inputs.fnbPerRoom;
          dayData.otherRevAmt = dayData.rooms * inputs.otherRev;

          let mtgRooms = 0;
          (inputs.segments || []).forEach((s) => {
            if (s.category === "grp" && dayData.segs[s.key]) {
              mtgRooms += Number(dayData.segs[s.key].rooms) || 0;
            }
          });
          dayData.mtgRev = mtgRooms * inputs.mtgRevPerRoom;

          dayData.totalAncillary =
            dayData.fnbRev + dayData.mtgRev + dayData.otherRevAmt;
          dayData.totalRev = dayData.netRoomRev + dayData.totalAncillary;
          dayData.taxAmt = dayData.rev * (inputs.taxRate / 100);
        }

        if (dayOverrides[m] && dayOverrides[m][d]) {
          const ov = dayOverrides[m][d];

          if (ov.paidRooms !== undefined) {
            dayData.paidRooms = ov.paidRooms;
            dayData.rooms = ov.paidRooms + dayData.compNight;
            dayData.occ =
              inputs.capacity > 0 ? (dayData.rooms / inputs.capacity) * 100 : 0;
          }
          if (ov.occ !== undefined) {
            dayData.occ = ov.occ;
            dayData.rooms = Math.round((ov.occ / 100) * inputs.capacity);
            dayData.paidRooms = Math.max(0, dayData.rooms - dayData.compNight);
          }
          if (ov.rev !== undefined) {
            dayData.rev = ov.rev;
          }
          if (ov.adr !== undefined) {
            dayData.adr = ov.adr;
          }

          if (ov.paidRooms !== undefined && ov.adr === undefined) {
            dayData.rev = dayData.paidRooms * dayData.adr;
          } else if (ov.adr !== undefined && ov.paidRooms === undefined) {
            dayData.rev = dayData.paidRooms * dayData.adr;
          } else if (
            ov.rev !== undefined &&
            ov.paidRooms === undefined &&
            ov.adr === undefined
          ) {
            dayData.adr =
              dayData.paidRooms > 0 ? dayData.rev / dayData.paidRooms : 0;
          }

          dayData.revPAR = (dayData.occ * dayData.adr) / 100;

          let otaCommAmt = 0;
          (inputs.segments || []).forEach((s) => {
            if (s.category === "ota" && dayData.segs[s.key]) {
              otaCommAmt +=
                (Number(dayData.segs[s.key].rev) || 0) * (inputs.otaComm / 100);
            }
          });

          const gdsFee = dayData.rev * (inputs.channel / 100);
          const franchiseFee = dayData.rev * (inputs.franchise / 100);
          const loyaltyFee = dayData.rev * (inputs.loyalty / 100);
          const totalDistCost = otaCommAmt + gdsFee + franchiseFee + loyaltyFee;
          const netRoomRev = dayData.rev - totalDistCost;

          dayData.otaCommAmt = otaCommAmt;
          dayData.gdsFee = gdsFee;
          dayData.franchiseFee = franchiseFee;
          dayData.loyaltyFee = loyaltyFee;
          dayData.totalDistCost = totalDistCost;
          dayData.netRoomRev = netRoomRev;

          dayData.fnbRev = dayData.rooms * inputs.fnbPerRoom;
          dayData.otherRevAmt = dayData.rooms * inputs.otherRev;

          let mtgRooms = 0;
          (inputs.segments || []).forEach((s) => {
            if (s.category === "grp" && dayData.segs[s.key]) {
              mtgRooms += Number(dayData.segs[s.key].rooms) || 0;
            }
          });
          dayData.mtgRev = mtgRooms * inputs.mtgRevPerRoom;

          dayData.totalAncillary =
            dayData.fnbRev + dayData.mtgRev + dayData.otherRevAmt;
          dayData.totalRev = dayData.netRoomRev + dayData.totalAncillary;
          dayData.taxAmt = dayData.rev * (inputs.taxRate / 100);
        }
      });
      list.push(days);
    }
    return list;
  }, [year, inputs, segmentOverrides, dayOverrides]);

  const lyAllData = useMemo(() => {
    if (apiLyData && apiLyData.length > 0) {
      const list = [];
      for (let m = 0; m < 12; m++) {
        const daysInMonth = new Date(year, m + 1, 0).getDate();
        const monthDays = [];
        for (let d = 1; d <= daysInMonth; d++) {
          const dayDateStr = moment(new Date(year, m, d)).format("YYYY-MM-DD");
          let matchingData = apiLyData.filter(
            (x) =>
              moment(x.Date).format("MM-DD") ===
              moment(new Date(year, m, d)).format("MM-DD"),
          );

          // Filter out items that have null or undefined values
          matchingData = matchingData.filter(
            (item) =>
              item.RMS !== null && item.RMS !== undefined && item.RMS !== "",
          );

          let sumRms = 0;
          let sumRev = 0;

          if (matchingData.length > 0) {
            matchingData.forEach((item) => {
              sumRms += item.RMS ? parseInt(item.RMS) : 0;
              sumRev += item.REV ? parseInt(item.REV) : 0;
            });
          }

          const rms =
            matchingData.length > 0
              ? Math.round(sumRms / matchingData.length)
              : 0;
          const rev =
            matchingData.length > 0
              ? Math.round(sumRev / matchingData.length)
              : 0;
          const adr = rms > 0 ? rev / rms : 0;

          const lyDates = matchingData
            .map((item) => item.LY_Date)
            .filter(Boolean);
          monthDays.push({
            day: d,
            paidRooms: rms,
            rooms: rms,
            rev: rev,
            adr: adr,
            totalRev: rev,
            occ: capacity > 0 ? (rms / capacity) * 100 : 0,
            lyDates: lyDates,
          });
        }
        list.push(monthDays);
      }
      return list;
    }

    const lyInputs = {
      ...inputs,
      occTarget: occTarget * 0.955,
      baseADR: baseADR / (1 + adrGrowth / 100),
      adrGrowth: 0,
      demandGrowth: 0,
    };
    const list = [];
    for (let m = 0; m < 12; m++) {
      list.push(generateDayData(year - 1, m, lyInputs));
    }
    return list;
  }, [year, inputs, occTarget, baseADR, adrGrowth, apiLyData, capacity]);

  const sortedSegments = useMemo(() => {
    return [...segments].sort((a, b) => {
      let revA = 0;
      let revB = 0;
      allData.forEach((monthRows) => {
        monthRows.forEach((r) => {
          revA += r.segs?.[a.key]?.rev || 0;
          revB += r.segs?.[b.key]?.rev || 0;
        });
      });
      return revB - revA;
    });
  }, [segments, allData]);

  const activeMonthRows = allData[activeMonth];
  const activeLYMonthRows = lyAllData[activeMonth];

  // Aggregated calculations for active month
  const sumActive = (key) =>
    activeMonthRows.reduce((a, r) => a + (r[key] || 0), 0);
  const activeMonthAvail = activeMonthRows.length * capacity;
  const activeMonthRooms = sumActive("rooms");
  const activeMonthPaidRooms = sumActive("paidRooms");
  const activeMonthCompRooms = activeMonthRooms - activeMonthPaidRooms;
  const activeMonthOcc = (activeMonthRooms / activeMonthAvail) * 100;
  const activeMonthGrossRev = sumActive("rev");
  const activeMonthADR =
    activeMonthPaidRooms > 0 ? activeMonthGrossRev / activeMonthPaidRooms : 0;
  const activeMonthRevPAR = activeMonthGrossRev / activeMonthAvail;
  const activeMonthTRevPAR = sumActive("totalRev") / activeMonthAvail;

  const activeMonthOtaCommAmt = sumActive("otaCommAmt");
  const activeMonthGdsFee = sumActive("gdsFee");
  const activeMonthFranchiseFee = sumActive("franchiseFee");
  const activeMonthLoyaltyFee = sumActive("loyaltyFee");
  const activeMonthNetRoomRev = sumActive("netRoomRev");

  const activeMonthFnbRev = sumActive("fnbRev");
  const activeMonthMtgRev = sumActive("mtgRev");
  const activeMonthOtherRevAmt = sumActive("otherRevAmt");
  const activeMonthTotalAncillary = sumActive("totalAncillary");
  const activeMonthTotalRev = sumActive("totalRev");
  const activeMonthTaxAmt = sumActive("taxAmt");

  const activeMonthGrpPickup = sumActive("grpPickup");
  const activeMonthGrpBlocked = sumActive("grpBlocked");
  const activeMonthGrpWashRooms = activeMonthGrpBlocked - activeMonthGrpPickup;

  // YTD Calculations
  const ytdMonths = allData.slice(0, activeMonth + 1);
  const ytdFlat = ytdMonths.flat();
  const ytdPaid = ytdFlat.reduce((a, r) => a + r.paidRooms, 0);
  const ytdGross = ytdFlat.reduce((a, r) => a + r.rev, 0);
  const ytdNet = ytdFlat.reduce((a, r) => a + r.totalRev, 0);
  const ytdAvail = ytdFlat.length * capacity;
  const ytdOcc = (ytdFlat.reduce((a, r) => a + r.rooms, 0) / ytdAvail) * 100;
  const ytdADR = ytdPaid > 0 ? ytdGross / ytdPaid : 0;
  const ytdRevPAR = ytdGross / ytdAvail;
  const ytdTRevPAR = ytdNet / ytdAvail;
  const ytdDist = ytdFlat.reduce((a, r) => a + r.totalDistCost, 0);

  // Annual Totals (Dynamicized based on flattened engine calendar to secure absolute precision)
  const annualAvail = allData.flat().length * capacity;
  const annualPaidRooms = allData.flat().reduce((a, r) => a + r.paidRooms, 0);
  const annualOccRooms = allData.flat().reduce((a, r) => a + r.rooms, 0);
  const annualRoomRev = allData.flat().reduce((a, r) => a + r.rev, 0);
  const annualNetRev = allData.flat().reduce((a, r) => a + r.totalRev, 0);
  const annualOcc = (annualOccRooms / annualAvail) * 100;
  const annualADR = annualPaidRooms > 0 ? annualRoomRev / annualPaidRooms : 0;
  const annualRevPAR = annualRoomRev / annualAvail;
  const annualTRevPAR = annualNetRev / annualAvail;

  // Annual LY Totals
  const annualLYPaidRooms = lyAllData
    .flat()
    .reduce((a, r) => a + r.paidRooms, 0);
  const annualLYOccRooms = lyAllData.flat().reduce((a, r) => a + r.rooms, 0);
  const annualLYRoomRev = lyAllData.flat().reduce((a, r) => a + r.rev, 0);
  const annualLYNetRev = lyAllData.flat().reduce((a, r) => a + r.totalRev, 0);
  const annualLYOcc = (annualLYOccRooms / annualAvail) * 100;
  const annualLYADR =
    annualLYPaidRooms > 0 ? annualLYRoomRev / annualLYPaidRooms : 0;
  const annualLYRevPAR = annualLYRoomRev / annualAvail;
  const annualLYTRevPAR = annualLYNetRev / annualAvail;

  const varPct = (bgt, ly) => {
    if (!ly) return 0;
    return ((bgt - ly) / ly) * 100;
  };

  const getLYDay = (monthIdx, day) => {
    const row = lyAllData[monthIdx] && lyAllData[monthIdx][day - 1];
    return row
      ? {
          rooms: row.paidRooms,
          adr: row.adr,
          rev: row.rev,
          lyDates: row.lyDates,
        }
      : null;
  };

  // Month navigation calculation summaries
  const monthNavSummary = useMemo(() => {
    return allData.map((rows, i) => {
      const occSum = rows.reduce((a, r) => a + r.occ, 0) / rows.length;
      // const roomsSum = rows.reduce((a, r) => a + r.rooms, 0);
      const roomsSum = rows.reduce((a, r) => a + r.paidRooms, 0);
      return {
        idx: i,
        name: MONTHS_SHORT[i],
        occ: occSum,
        rooms: roomsSum,
      };
    });
  }, [allData]);

  // Segment Card summary calculations
  const segmentCardData = useMemo(() => {
    const totals = {};
    segments.forEach((s) => {
      totals[s.key] = { rooms: 0, rev: 0 };
    });
    activeMonthRows.forEach((r) => {
      segments.forEach((s) => {
        if (r.segs[s.key]) {
          totals[s.key].rooms += r.segs[s.key].rooms;
          totals[s.key].rev += r.segs[s.key].rev;
        }
      });
    });
    return sortedSegments.map((s) => {
      const adr =
        totals[s.key].rooms > 0 ? totals[s.key].rev / totals[s.key].rooms : 0;
      return {
        ...s,
        rooms: totals[s.key].rooms,
        rev: totals[s.key].rev,
        adr,
      };
    });
  }, [activeMonthRows, sortedSegments]);

  // Chart data
  const chart1Data = useMemo(
    () => ({
      labels: activeMonthRows.map((r) => r.day),
      datasets: sortedSegments.map((s) => ({
        label: s.label,
        data: activeMonthRows.map((r) => r.segs[s.key]?.rooms || 0),
        backgroundColor: s.color,
        stack: "rooms",
        barThickness: 6,
        hidden: !!hiddenSegments[s.key],
      })),
    }),
    [activeMonthRows, sortedSegments, hiddenSegments],
  );

  // Clean up tooltip element on unmount
  useEffect(() => {
    if (api === 0) return;
    return () => {
      const el = document.getElementById("chartjs-tooltip");
      if (el) {
        el.remove();
      }
    };
  }, []);

  // Custom HTML Tooltip Handler to support scrollbars
  const externalTooltipHandler = (context) => {
    let tooltipEl = document.getElementById("chartjs-tooltip");

    if (!tooltipEl) {
      tooltipEl = document.createElement("div");
      tooltipEl.id = "chartjs-tooltip";
      tooltipEl.style.background = "rgba(20, 26, 46, 0.95)";
      tooltipEl.style.borderRadius = "8px";
      tooltipEl.style.color = "white";
      tooltipEl.style.opacity = 0;
      tooltipEl.style.position = "absolute";
      tooltipEl.style.pointerEvents = "auto";
      tooltipEl.style.transition = "opacity 0.15s ease, transform 0.1s ease";
      tooltipEl.style.fontSize = "11px";
      tooltipEl.style.fontFamily = "Inter, sans-serif";
      tooltipEl.style.padding = "8px 12px";
      tooltipEl.style.boxShadow = "0 6px 20px rgba(0, 0, 0, 0.3)";
      tooltipEl.style.border = "1px solid rgba(255, 255, 255, 0.15)";
      tooltipEl.style.zIndex = "10000";
      tooltipEl.style.width = "240px";

      tooltipEl.onmouseenter = () => {
        tooltipEl.style.opacity = "1";
      };
      tooltipEl.onmouseleave = () => {
        tooltipEl.style.opacity = "0";
      };

      document.body.appendChild(tooltipEl);
    }

    const tooltipModel = context.tooltip;

    if (tooltipModel.opacity === 0) {
      if (!tooltipEl.matches(":hover")) {
        tooltipEl.style.opacity = 0;
      }
      return;
    }

    if (tooltipModel.body) {
      const titleLines = tooltipModel.title || [];
      const bodyLines = tooltipModel.body.map((bodyItem) => bodyItem.lines);

      let innerHtml = "";

      titleLines.forEach((title) => {
        innerHtml += `<div style="font-weight: 700; font-size: 12px; margin-bottom: 6px; border-bottom: 1px solid rgba(255,255,255,0.2); padding-bottom: 4px;">Day ${title}</div>`;
      });

      innerHtml += `<div class="chartjs-tooltip-scroll" style="max-height: 120px; overflow-y: auto; display: flex; flex-direction: column; gap: 4px; padding-right: 4px;">`;

      bodyLines.forEach((body, i) => {
        const colors = tooltipModel.labelColors[i];
        const colorSpan = `<span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: ${colors.backgroundColor}; margin-right: 6px; flex-shrink: 0;"></span>`;
        const lineText = body[0] || "";
        const parts = lineText.split(":");
        const label = parts[0] ? parts[0].trim() : "";
        const val = parts[1] ? parts[1].trim() : "";

        innerHtml += `<div style="display: flex; align-items: center; justify-content: space-between; gap: 10px; font-size: 11px;">
          <span style="display: flex; align-items: center; text-transform: capitalize; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${colorSpan}${label}</span>
          <span style="font-weight: 600;">${val}</span>
        </div>`;
      });

      innerHtml += `</div>`;

      tooltipEl.innerHTML = innerHtml;
    }

    const position = context.chart.canvas.getBoundingClientRect();

    tooltipEl.style.opacity = 1;
    let leftPos = position.left + window.pageXOffset + tooltipModel.caretX + 12;
    let topPos = position.top + window.pageYOffset + tooltipModel.caretY - 60;

    const tooltipWidth = 240;
    if (leftPos + tooltipWidth > window.innerWidth) {
      leftPos =
        position.left +
        window.pageXOffset +
        tooltipModel.caretX -
        tooltipWidth -
        12;
    }

    tooltipEl.style.left = leftPos + "px";
    tooltipEl.style.top = topPos + "px";
  };

  const chart1Options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
        mode: "index",
        intersect: false,
        itemSort: (a, b) => b.raw - a.raw,
        external: externalTooltipHandler,
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          maxRotation: 0,
          autoSkip: true,
          maxTicksLimit: 16,
          font: { size: 10 },
        },
        grid: { display: false },
      },
      y: {
        stacked: true,
        ticks: { font: { size: 10 } },
        grid: { color: "rgba(0,0,0,0.05)" },
      },
    },
  };

  const chart2Data = useMemo(
    () => ({
      labels: activeMonthRows.map((r) => r.day),
      datasets: sortedSegments.map((s) => ({
        label: s.label,
        data: activeMonthRows.map(
          (r) => +((r.segs[s.key]?.rev || 0) / 1000).toFixed(1),
        ),
        backgroundColor: s.color,
        stack: "rev",
        barThickness: 6,
        hidden: !!hiddenSegments2[s.key],
      })),
    }),
    [activeMonthRows, sortedSegments, hiddenSegments2],
  );

  // 1. Put this with your hooks at the top of the BudgetSimulator component
  const yearOptions = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = currentYear - 2; y <= currentYear + 5; y++) {
      years.push(y);
    }
    return years;
  }, []);

  const chart2Options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
        mode: "index",
        intersect: false,
        itemSort: (a, b) => b.raw - a.raw,
        external: externalTooltipHandler,
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          maxRotation: 0,
          autoSkip: true,
          maxTicksLimit: 16,
          font: { size: 10 },
        },
        grid: { display: false },
      },
      y: {
        stacked: true,
        ticks: { font: { size: 10 }, callback: (v) => `$${v}K` },
        grid: { color: "rgba(0,0,0,0.05)" },
      },
    },
  };

  const handleApplyLY = async () => {
    if (api === 0) return;
    if (selectedYears.length > 0) {
      setApiLyLoading(true);
      await fetchLyData(selectedYears, isDatewise);
      setShowLY(true);
    } else {
      setShowLY(false);
    }
    document.body.click(); // Close popover
  };

  const handleDatewiseApplyLY = async (isChecked) => {
    if (api === 0) return;
    setIsDatewise(isChecked);
    setIsDatewiseLoading(true);
    await fetchLyData(selectedYears, isChecked);
    setIsDatewiseLoading(false);
  };

  const compareYearOptions = useMemo(() => {
    const options = [];
    for (let i = 1; i <= 8; i++) {
      const prevYear = year - i;
      options.push({ value: prevYear, label: prevYear.toString() });
    }
    return options;
  }, [year]);

  const lyPopover = (
    <Popover id="ly-compare-popover" style={{ minWidth: "380px" }}>
      <Popover.Header as="h6">Compare with Previous Years</Popover.Header>

      <Popover.Body>
        <div className="mb-3">
          <label className="form-label fw-semibold">Select Year(s)</label>

          <Select
            isMulti
            closeMenuOnSelect={false}
            options={compareYearOptions}
            value={selectedYears}
            onChange={(value) => setSelectedYears(value || [])}
            placeholder="Choose year(s)"
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 1000, width: "40%" }),
            }}
          />
        </div>

        <div className="d-flex justify-content-end gap-2">
          <Button
            size="sm"
            variant="outline-secondary"
            onClick={() => {
              if (api === 0) return;
              setSelectedYears([]);
              setShowLY(false);
            }}
          >
            Clear
          </Button>

          <Button size="sm" variant="primary" onClick={handleApplyLY}>
            Apply
          </Button>
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      {propertyCode ? (
    <div
      className="widget-container bs-style-1"
      style={{ position: "relative" }}
    >
      <div className="d-flex justify-content-between align-items-baseline">
        <header className="groupwash-header mb-0">
          <h6>Budget Simulator</h6>
        </header>
      </div>

      <div className="budget-simulator-container">
        {/* {apiLyLoading && <Loader />} */}

        {/* CONTROLS BAR */}
        <div className="controls">
          <div className="ctrl-group">
            <span className="ctrl-label">Budget Year</span>
            <select
              value={year}
              onChange={(e) => setYear(parseInt(e.target.value))}
            >
              {yearOptions.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>
          <div className="ctrl-group">
            <span className="ctrl-label">View Mode</span>
            <select
              value={viewMode}
              onChange={(e) => setViewMode(e.target.value)}
            >
              <option value="rooms">Rooms + Revenue</option>
              <option value="rooms_only">Rooms Only</option>
              <option value="revenue_only">Revenue Only</option>
              <option value="adr">ADR Focus</option>
            </select>
          </div>
          <div className="ctrl-group">
            <span className="ctrl-label">Segment</span>
            <Select
              value={
                segOptions.filter((opt) => opt.value === segFilter) || null
              }
              options={segOptions}
              onChange={(opt) => setSegFilter(opt ? opt.value : "all")}
              isSearchable={false}
              isClearable={false}
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "32px",
                  height: "32px",
                  width: "200px",
                  fontSize: "13px",
                  borderRadius: "6px",
                  borderColor: "#cfd9f8",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "none",
                  "&:hover": {
                    borderColor: "#3565FC",
                  },
                }),
                valueContainer: (provided) => ({
                  ...provided,
                  height: "32px",
                  padding: "0 8px",
                  display: "flex",
                  alignItems: "center",
                }),
                singleValue: (provided) => ({
                  ...provided,
                  color: "#202842",
                  margin: "0",
                }),
                input: (provided) => ({
                  ...provided,
                  margin: "0",
                  padding: "0",
                }),
                indicatorsContainer: (provided) => ({
                  ...provided,
                  height: "32px",
                }),
                dropdownIndicator: (provided) => ({
                  ...provided,
                  padding: "4px",
                }),
                indicatorSeparator: () => ({
                  display: "none",
                }),
                menu: (provided) => ({
                  ...provided,
                  fontSize: "13px",
                  zIndex: 10,
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isSelected
                    ? "rgba(53, 101, 252, 0.15)"
                    : state.isFocused
                      ? "rgba(53, 101, 252, 0.05)"
                      : "transparent",
                  color: state.isSelected ? "#3565FC" : "#202842",
                  cursor: "pointer",
                  padding: "8px 12px",
                  "&:active": {
                    backgroundColor: "rgba(53, 101, 252, 0.15)",
                  },
                }),
              }}
            />
          </div>
          <div className="ctrl-group">
            <span className="ctrl-label">Base Rooms</span>
            <input
              className="ctrl-input ctrl-input-width"
              type="number"
              value={capacity}
              min={50}
              max={1000}
              onChange={(e) => setCapacity(parseInt(e.target.value) || 0)}
            />
          </div>
          <div className="spacer"></div>
          <OverlayTrigger
            trigger="click"
            rootClose
            placement="bottom"
            overlay={lyPopover}
          >
            <Button
              className={`default-btn ${showLY ? "btn-ly-active" : "primary-btn"} cursor-pointer`}
              title="Show Last Year actuals alongside budget for comparison"
            >
              LY Compare
            </Button>
          </OverlayTrigger>
          <Button
            onClick={resetSeasonality}
            className="default-btn primary-btn cursor-pointer ms-0"
          >
            ↺ Reset Seasonality
          </Button>
          <Button
            className="default-btn primary-btn cursor-pointer ms-0"
            disabled={
              segFilter !== "all" || viewMode !== "rooms" || saveLoading
            }
            onClick={handleSave}
            // title="Save budget data to database"
            style={{ marginLeft: "10px" }}
          >
            {saveLoading ? "Saving..." : "Save"}
          </Button>
        </div>
        {apiLyLoading ? (
          <Loader />
        ) : (
          <>
            {/* KPI ROW */}
            <div className="kpi-row" style={{ marginBottom: "8px" }}>
              {[
                {
                  label: "Paid Room Nights",
                  val: fmtNum(annualPaidRooms),
                  ly: fmtNum(annualLYPaidRooms),
                  var: varPct(annualPaidRooms, annualLYPaidRooms),
                  unit: "rms",
                },
                {
                  label: "Gross Room Rev",
                  val: fmtDollar(annualRoomRev / 1000, 0) + "K",
                  ly: fmtDollar(annualLYRoomRev / 1000, 0) + "K",
                  var: varPct(annualRoomRev, annualLYRoomRev),
                },
                {
                  label: "Occupancy",
                  val: fmtPct(annualOcc),
                  ly: fmtPct(annualLYOcc),
                  var: varPct(annualOcc, annualLYOcc),
                },
                {
                  label: "Blended ADR",
                  val: fmtDollar(annualADR, 2),
                  ly: fmtDollar(annualLYADR, 2),
                  var: varPct(annualADR, annualLYADR),
                },
                {
                  label: "RevPAR",
                  val: fmtDollar(annualRevPAR, 2),
                  ly: fmtDollar(annualLYRevPAR, 2),
                  var: varPct(annualRevPAR, annualLYRevPAR),
                },
                {
                  label: "TRevPAR",
                  val: fmtDollar(annualTRevPAR, 2),
                  ly: fmtDollar(annualLYTRevPAR, 2),
                  var: varPct(annualTRevPAR, annualLYTRevPAR),
                },
              ].map((kpi, idx) => (
                <div key={idx} className="kpi-card">
                  <div className="kpi-label">{kpi.label}</div>
                  <div className="kpi-val-row">
                    <span className="kpi-val">{kpi.val}</span>
                    {kpi.unit && <span className="kpi-unit">{kpi.unit}</span>}
                  </div>
                  {showLY ? (
                    <div className="kpi-change">
                      <span
                        className={`kpi-badge ${kpi.var > 0 ? "kpi-badge-green" : kpi.var < 0 ? "kpi-badge-red" : "kpi-badge-flat"}`}
                      >
                        {kpi.var > 0 ? "↑" : kpi.var < 0 ? "↓" : "•"}
                      </span>
                      <span className="kpi-change-text">
                        {kpi.var > 0
                          ? `+${kpi.var.toFixed(1)}`
                          : kpi.var.toFixed(1)}
                        % vs LY ({kpi.ly})
                      </span>
                    </div>
                  ) : (
                    <div className="kpi-change-empty">&nbsp;</div>
                  )}
                </div>
              ))}
            </div>

            {/* MONTH TABS AND SEASONALITY */}
            <div className="content pt-0 px-3 pb-1">
              {/* <div className="d-flex justify-content-between align-items-center mb-1">
            <Button onClick={resetSeasonality} className="default-btn primary-btn cursor-pointer ms-0">
              ↺ Reset Seasonality
            </Button>
          </div> */}
              <div
                className="month-tabs-container"
                style={{
                  display: "flex",
                  gap: "12px",
                  overflowX: "auto",
                  WebkitOverflowScrolling: "touch",
                }}
              >
                {monthNavSummary.map((m) => {
                  const isActive = m.idx === activeMonth;
                  return (
                    <div
                      key={m.idx}
                      className="shadow-sm month-card-wrapper"
                      onClick={() => setActiveMonth(m.idx)}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        minWidth: "110px",
                        flex: "0 0 auto",
                        backgroundColor: isActive ? "#FFFFFF" : "#F8FAFC",
                        border: isActive
                          ? "2px solid #3B82F6"
                          : "1px solid #E2E8F0",
                        borderRadius: "8px",
                        padding: "8px 10px",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        boxShadow: isActive
                          ? "0 4px 6px -1px rgba(59, 130, 246, 0.1), 0 2px 4px -1px rgba(59, 130, 246, 0.06)"
                          : "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      {/* TOP: Month Info */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "2px",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "700",
                            fontSize: "14px",
                            color: isActive ? "#3B82F6" : "#475569",
                          }}
                        >
                          {m.name}
                        </div>
                        <div
                          style={{
                            fontSize: "10px",
                            fontWeight: "600",
                            color: isActive ? "#64748B" : "#94A3B8",
                          }}
                        >
                          {fmtNum(m.rooms)} rms
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: "11px",
                          color: isActive ? "#2563EB" : "#64748B",
                          marginBottom: "8px",
                          fontWeight: "600",
                        }}
                      >
                        {fmtPct(m.occ)} occ
                      </div>

                      {/* BOTTOM: Multiplier Inputs */}
                      <div
                        className="month-inputs"
                        style={{
                          display: "flex",
                          gap: "6px",
                          justifyContent: "space-between",
                          borderTop: "1px dashed #E2E8F0",
                          paddingTop: "8px",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "48%",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "9px",
                              color: "#64748B",
                              fontWeight: "700",
                              marginBottom: "2px",
                              textAlign: "center",
                              letterSpacing: "0.5px",
                            }}
                          >
                            OCC ×
                          </span>
                          <input
                            type="number"
                            value={occSeason[m.idx]}
                            step={0.01}
                            min={0.3}
                            max={1.5}
                            onChange={(e) =>
                              handleOccSeasonChange(m.idx, e.target.value)
                            }
                            style={{
                              width: "100%",
                              padding: "4px 2px",
                              fontSize: "12px",
                              textAlign: "center",
                              border: "1px solid #CBD5E1",
                              borderRadius: "4px",
                              backgroundColor: isActive ? "#F0FDF4" : "#FFFFFF",
                              color: "#334155",
                              fontWeight: "600",
                              outline: "none",
                              boxShadow: "inset 0 1px 2px rgba(0,0,0,0.02)",
                            }}
                            title={`Occupancy multiplier for ${MONTHS[m.idx]}`}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "48%",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "9px",
                              color: "#64748B",
                              fontWeight: "700",
                              marginBottom: "2px",
                              textAlign: "center",
                              letterSpacing: "0.5px",
                            }}
                          >
                            ADR ×
                          </span>
                          <input
                            type="number"
                            value={adrSeason[m.idx]}
                            step={0.01}
                            min={0.5}
                            max={1.5}
                            onChange={(e) =>
                              handleAdrSeasonChange(m.idx, e.target.value)
                            }
                            style={{
                              width: "100%",
                              padding: "4px 2px",
                              fontSize: "12px",
                              textAlign: "center",
                              border: "1px solid #CBD5E1",
                              borderRadius: "4px",
                              backgroundColor: isActive ? "#FFF7ED" : "#FFFFFF",
                              color: "#334155",
                              fontWeight: "600",
                              outline: "none",
                              boxShadow: "inset 0 1px 2px rgba(0,0,0,0.02)",
                            }}
                            title={`ADR multiplier for ${MONTHS[m.idx]}`}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* TOP LEVEL TABS */}
            <div
              className="d-flex mb-0 border-bottom px-3"
              style={{ gap: "20px" }}
            >
              <button
                className="btn btn-link text-decoration-none"
                onClick={() => setActiveMainTab("breakdown")}
                style={{
                  // padding: "12px 16px",
                  borderRadius: 0,
                  borderBottom:
                    activeMainTab === "breakdown"
                      ? "3px solid #3B82F6"
                      : "3px solid transparent",
                  color: activeMainTab === "breakdown" ? "#1E293B" : "#64748B",
                  fontWeight: activeMainTab === "breakdown" ? "600" : "500",
                  fontSize: "15px",
                  transition: "all 0.2s",
                }}
              >
                Detailed Budget Breakdown
              </button>
              <button
                className="btn btn-link text-decoration-none"
                onClick={() => setActiveMainTab("summary")}
                style={{
                  // padding: "12px 16px",
                  borderRadius: 0,
                  borderBottom:
                    activeMainTab === "summary"
                      ? "3px solid #3B82F6"
                      : "3px solid transparent",
                  color: activeMainTab === "summary" ? "#1E293B" : "#64748B",
                  fontWeight: activeMainTab === "summary" ? "600" : "500",
                  fontSize: "15px",
                  transition: "all 0.2s",
                }}
              >
                Segment Summary & Charts
              </button>
            </div>

            {activeMainTab === "breakdown" && (
              <div className="tab-pane-breakdown w-100">
                {/* MAIN LAYOUT */}
                <div className="main-body">
                  {/* CONTENT AREA */}
                  <div className="content">
                    <div className="">
                      {/* DAY-BY-DAY TABLE */}
                      <div className="ViewPropertySetupTable">
                        <div className="stripped__table">
                          <Table responsive>
                            <thead>
                              <tr>
                                <th
                                  rowSpan={2}
                                  colspan={3}
                                  className="th-left-pad border_right text-center"
                                >
                                  DATE
                                </th>
                                {/* <th
                                  rowSpan={3}
                                  className="th-left-pad border_right text-center"
                                >
                                  EVENTS
                                </th> */}
                                {/* <th
                                  rowSpan={2}
                                  className="th-left-pad border_right text-center"
                                >
                                  DAY
                                </th> */}
                                {/* Budget Forecast Group */}
                                <th
                                  colSpan={viewMode !== "rooms_only" ? 4 : 2}
                                  className="text-center border_right"
                                >
                                  Budget Forecast
                                </th>
                                {/* Total LY Group */}
                                {showLY && (
                                  <th
                                    colSpan={viewMode !== "rooms_only" ? 4 : 3}
                                    className="ly-group-head text-center border_right"
                                  >
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                      <div className="width45">Total LY</div>

                                      <div
                                        className="form-check form-switch no-border-break from-groups jay-put-this-checkbox mb-0"
                                        style={{
                                          minHeight: "auto",
                                          paddingTop: "2px",
                                        }}
                                      >
                                        <span className="pe-1">DATE</span>
                                        {isDatewiseLoading ? (
                                          <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        ) : (
                                          <input
                                            id={commonService.generateGlobalClickTrackerID(
                                              "BudgetSimulator",
                                              "ly-switch-btn",
                                              "",
                                            )}
                                            className="form-check-input m-0 cursor-pointer"
                                            type="checkbox"
                                            role="switch"
                                            checked={isDatewise}
                                            onChange={(e) => {
                                              handleDatewiseApplyLY(
                                                e?.target.checked ?? false,
                                              );
                                            }}
                                          />
                                        )}
                                        <span className="ps-1">DOW</span>
                                      </div>
                                    </div>
                                  </th>
                                )}
                                {showLY && (
                                  <th
                                    colSpan={viewMode !== "rooms_only" ? 3 : 2}
                                    className="ly-group-head-var text-center border_right"
                                  >
                                    Total LY vs OTB
                                  </th>
                                )}
                                {segFilter === "all" ? (
                                  <>
                                    {sortedSegments.map((s) => {
                                      let colSpan = 2;
                                      if (viewMode === "adr") colSpan = 3;
                                      else if (
                                        viewMode === "rooms_only" ||
                                        viewMode === "revenue_only"
                                      )
                                        colSpan = 1;
                                      return (
                                        <th
                                          key={s.key}
                                          colSpan={colSpan}
                                          className="seg-group-header text-center border_right"
                                        >
                                          {s.label.toUpperCase()}
                                        </th>
                                      );
                                    })}
                                  </>
                                ) : (
                                  <>
                                    {(() => {
                                      const s =
                                        segments.find(
                                          (x) => x.key === segFilter,
                                        ) || segments[0];
                                      return (
                                        <th
                                          colSpan={3}
                                          className="seg-group-header text-center border_right"
                                        >
                                          {s?.label.toUpperCase()}
                                        </th>
                                      );
                                    })()}
                                  </>
                                )}
                              </tr>
                              <tr>
                                {/* Budget Forecast Sub-columns */}
                                <th className="text-center">
                                  TOTAL ROOM
                                  <br />
                                  SOLD
                                </th>
                                <th
                                  className={`text-center ${viewMode === "rooms_only" ? "border_right" : ""}`}
                                >
                                  OCC%
                                </th>
                                {viewMode !== "rooms_only" && (
                                  <>
                                    <th className="text-center">
                                      TOTAL
                                      <br />
                                      REVENUE
                                    </th>
                                    <th className="text-center border_right">
                                      ADR
                                    </th>
                                  </>
                                )}

                                {/* Total LY Sub-columns */}
                                {showLY && (
                                  <>
                                    <th
                                      colSpan={2}
                                      className="ly-group-head text-center"
                                    >
                                      LY
                                      <br />
                                      ROOMS
                                    </th>
                                    <th
                                      className={`ly-group-head text-right ${viewMode === "rooms_only" ? "border_right" : ""}`}
                                    >
                                      LY
                                      <br />
                                      ADR
                                    </th>
                                    {viewMode !== "rooms_only" && (
                                      <th className="ly-group-head text-right border_right">
                                        LY
                                        <br />
                                        REV
                                      </th>
                                    )}
                                    <th className="ly-group-head-var text-center">
                                      Δ RMS
                                      <br />
                                      VS LY
                                    </th>
                                    <th
                                      className={`ly-group-head-var text-right ${viewMode === "rooms_only" ? "border_right" : ""}`}
                                    >
                                      Δ ADR
                                      <br />
                                      VS LY
                                    </th>
                                    {viewMode !== "rooms_only" && (
                                      <th className="ly-group-head-var text-right border_right">
                                        Δ REV
                                        <br />
                                        VS LY
                                      </th>
                                    )}
                                  </>
                                )}
                                {segFilter === "all" ? (
                                  <>
                                    {sortedSegments.map((s) => (
                                      <React.Fragment key={s.key}>
                                        {viewMode !== "revenue_only" && (
                                          <th
                                            className={`seg-head text-center ${viewMode === "rooms_only" ? "seg-last-col border_right" : ""}`}
                                          >
                                            RMS
                                          </th>
                                        )}
                                        {viewMode !== "rooms_only" && (
                                          <th
                                            className={`seg-head text-center ${viewMode !== "adr" ? "seg-last-col border_right" : ""}`}
                                          >
                                            REV
                                          </th>
                                        )}
                                        {viewMode === "adr" && (
                                          <th className="seg-head text-center seg-last-col border_right">
                                            ADR
                                          </th>
                                        )}
                                      </React.Fragment>
                                    ))}
                                  </>
                                ) : (
                                  <>
                                    <th className="seg-head text-center">
                                      ROOMS
                                    </th>
                                    <th className="seg-head text-center">
                                      REV
                                    </th>
                                    <th className="seg-head text-center seg-last-col border_right">
                                      ADR
                                    </th>
                                  </>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {/* Totals Row */}
                              <tr className="shadowOnHover total-row">
                                <td
                                  colSpan={3}
                                  className="boldTd td-total border_right"
                                >
                                  TOTAL
                                </td>
                                {/* <td className="boldTd">{fmtNum(activeMonthRooms)}</td> */}
                                <td className="boldTd">
                                  {(() => {
                                    const ov =
                                      totalOverrides[activeMonth] || {};
                                    const val =
                                      ov.paidRooms !== undefined
                                        ? ov.paidRooms
                                        : Math.round(activeMonthPaidRooms);
                                    return (
                                      <input
                                        type="number"
                                        className="form-control form-control-sm text-center override-input"
                                        style={{
                                          width: "60px",
                                          padding: "2px",
                                          height: "24px",
                                          fontSize: "11px",
                                          display: "inline-block",
                                          backgroundColor:
                                            ov.paidRooms !== undefined
                                              ? "#fef3c7"
                                              : "white",
                                        }}
                                        value={val}
                                        onChange={(e) =>
                                          handleTotalEdit(
                                            activeMonth,
                                            "paidRooms",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    );
                                  })()}
                                </td>
                                <td className="boldTd">
                                  {(() => {
                                    const ov =
                                      totalOverrides[activeMonth] || {};
                                    const val =
                                      ov.occ !== undefined
                                        ? ov.occ
                                        : Number(activeMonthOcc.toFixed(1));
                                    return (
                                      <div className="d-flex align-items-center justify-content-center">
                                        <input
                                          type="number"
                                          className="form-control form-control-sm text-center override-input"
                                          style={{
                                            width: "60px",
                                            padding: "2px",
                                            height: "24px",
                                            fontSize: "11px",
                                            display: "inline-block",
                                            backgroundColor:
                                              ov.occ !== undefined
                                                ? "#fef3c7"
                                                : "white",
                                          }}
                                          value={val}
                                          onChange={(e) =>
                                            handleTotalEdit(
                                              activeMonth,
                                              "occ",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </div>
                                    );
                                  })()}
                                </td>
                                {viewMode !== "rooms_only" && (
                                  <>
                                    <td className="boldTd text-right">
                                      {(() => {
                                        const ov =
                                          totalOverrides[activeMonth] || {};
                                        const val =
                                          ov.rev !== undefined
                                            ? ov.rev
                                            : Math.round(activeMonthGrossRev);
                                        return (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm text-center override-input"
                                            style={{
                                              width: "70px",
                                              padding: "2px",
                                              height: "24px",
                                              fontSize: "11px",
                                              display: "inline-block",
                                              backgroundColor:
                                                ov.rev !== undefined
                                                  ? "#fef3c7"
                                                  : "white",
                                            }}
                                            value={val}
                                            onChange={(e) =>
                                              handleTotalEdit(
                                                activeMonth,
                                                "rev",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        );
                                      })()}
                                    </td>
                                    <td className="boldTd text-right border_right">
                                      {(() => {
                                        const ov =
                                          totalOverrides[activeMonth] || {};
                                        const val =
                                          ov.adr !== undefined
                                            ? ov.adr
                                            : Number(activeMonthADR.toFixed(2));
                                        return (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm text-center override-input"
                                            style={{
                                              width: "60px",
                                              padding: "2px",
                                              height: "24px",
                                              fontSize: "11px",
                                              display: "inline-block",
                                              backgroundColor:
                                                ov.adr !== undefined
                                                  ? "#fef3c7"
                                                  : "white",
                                            }}
                                            value={val}
                                            onChange={(e) =>
                                              handleTotalEdit(
                                                activeMonth,
                                                "adr",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        );
                                      })()}
                                    </td>
                                  </>
                                )}
                                {showLY &&
                                  (() => {
                                    const lyRoomsTotal =
                                      activeLYMonthRows.reduce(
                                        (a, r) => a + r.paidRooms,
                                        0,
                                      );
                                    const lyRevTotal = activeLYMonthRows.reduce(
                                      (a, r) => a + r.rev,
                                      0,
                                    );
                                    const lyADRTotal =
                                      lyRoomsTotal > 0
                                        ? lyRevTotal / lyRoomsTotal
                                        : 0;
                                    return (
                                      <>
                                        <td
                                          colSpan={2}
                                          className="boldTd val-ly"
                                        >
                                          {fmtNum(lyRoomsTotal)}
                                        </td>
                                        <td className="boldTd val-ly text-right">
                                          {fmtDollar(lyADRTotal, 2)}
                                        </td>
                                        {viewMode !== "rooms_only" && (
                                          <td className="boldTd val-ly text-right border_right">
                                            {fmtDollar(lyRevTotal, 0)}
                                          </td>
                                        )}
                                        <td
                                          className={`boldTd ${
                                            //  activeMonthRooms - lyRoomsTotal > 0
                                            activeMonthPaidRooms -
                                              lyRoomsTotal >
                                            0
                                              ? "val-var-pos"
                                              : "val-var-neg"
                                          }`}
                                        >
                                          {/* {activeMonthRooms - lyRoomsTotal > 0 */}
                                          {activeMonthPaidRooms - lyRoomsTotal >
                                          0
                                            ? "+"
                                            : ""}
                                          {fmtNum(
                                            //  activeMonthRooms - lyRoomsTotal,
                                            activeMonthPaidRooms - lyRoomsTotal,
                                          )}
                                        </td>
                                        <td
                                          className={`boldTd ${activeMonthADR - lyADRTotal > 0 ? "val-var-pos" : "val-var-neg"} text-right`}
                                        >
                                          {activeMonthADR - lyADRTotal > 0
                                            ? "+"
                                            : ""}
                                          {fmtDollar(
                                            activeMonthADR - lyADRTotal,
                                            2,
                                          )}
                                        </td>
                                        {viewMode !== "rooms_only" && (
                                          <td
                                            className={`boldTd ${activeMonthGrossRev - lyRevTotal > 0 ? "val-var-pos" : "val-var-neg"} text-right border_right`}
                                          >
                                            {activeMonthGrossRev - lyRevTotal >
                                            0
                                              ? "+"
                                              : ""}
                                            {fmtDollar(
                                              activeMonthGrossRev - lyRevTotal,
                                              0,
                                            )}
                                          </td>
                                        )}
                                      </>
                                    );
                                  })()}
                                {segFilter === "all" ? (
                                  <>
                                    {sortedSegments.map((s) => {
                                      const segRms = activeMonthRows.reduce(
                                        (a, r) =>
                                          a + (r.segs[s.key]?.rooms || 0),
                                        0,
                                      );
                                      const segRev = activeMonthRows.reduce(
                                        (a, r) => a + (r.segs[s.key]?.rev || 0),
                                        0,
                                      );
                                      const segAdr =
                                        segRms > 0 ? segRev / segRms : 0;
                                      return (
                                        <React.Fragment key={s.key}>
                                          {viewMode !== "revenue_only" && (
                                            <td
                                              className={`boldTd ${
                                                viewMode === "rooms_only"
                                                  ? "seg-last-col border_right"
                                                  : ""
                                              }`}
                                            >
                                              {(() => {
                                                const ov =
                                                  totalOverrides[activeMonth] ||
                                                  {};
                                                const field = `seg_${s.key}_rooms`;
                                                const val =
                                                  ov[field] !== undefined
                                                    ? ov[field]
                                                    : Math.round(segRms);
                                                return (
                                                  <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center override-input"
                                                    style={{
                                                      width: "60px",
                                                      padding: "2px",
                                                      height: "24px",
                                                      fontSize: "11px",
                                                      display: "inline-block",
                                                      backgroundColor:
                                                        ov[field] !== undefined
                                                          ? "#fef3c7"
                                                          : "white",
                                                    }}
                                                    value={val}
                                                    onChange={(e) =>
                                                      handleTotalEdit(
                                                        activeMonth,
                                                        field,
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                );
                                              })()}
                                            </td>
                                          )}
                                          {viewMode !== "rooms_only" && (
                                            <td
                                              className={`boldTd text-right ${viewMode !== "adr" ? "seg-last-col border_right" : ""}`}
                                            >
                                              {(() => {
                                                const ov =
                                                  totalOverrides[activeMonth] ||
                                                  {};
                                                const field = `seg_${s.key}_rev`;
                                                const val =
                                                  ov[field] !== undefined
                                                    ? ov[field]
                                                    : Math.round(segRev);
                                                return (
                                                  <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center override-input"
                                                    style={{
                                                      width: "70px",
                                                      padding: "2px",
                                                      height: "24px",
                                                      fontSize: "11px",
                                                      display: "inline-block",
                                                      backgroundColor:
                                                        ov[field] !== undefined
                                                          ? "#fef3c7"
                                                          : "white",
                                                    }}
                                                    value={val}
                                                    onChange={(e) =>
                                                      handleTotalEdit(
                                                        activeMonth,
                                                        field,
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                );
                                              })()}
                                            </td>
                                          )}
                                          {viewMode === "adr" && (
                                            <td className="boldTd text-right seg-last-col">
                                              {(() => {
                                                const ov =
                                                  totalOverrides[activeMonth] ||
                                                  {};
                                                const field = `seg_${s.key}_adr`;
                                                const val =
                                                  ov[field] !== undefined
                                                    ? ov[field]
                                                    : Number(segAdr.toFixed(2));
                                                return (
                                                  <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center override-input"
                                                    style={{
                                                      width: "60px",
                                                      padding: "2px",
                                                      height: "24px",
                                                      fontSize: "11px",
                                                      display: "inline-block",
                                                      backgroundColor:
                                                        ov[field] !== undefined
                                                          ? "#fef3c7"
                                                          : "white",
                                                    }}
                                                    value={val}
                                                    onChange={(e) =>
                                                      handleTotalEdit(
                                                        activeMonth,
                                                        field,
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                );
                                              })()}
                                            </td>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                                  </>
                                ) : (
                                  (() => {
                                    const segRms = activeMonthRows.reduce(
                                      (a, r) =>
                                        a + (r.segs[segFilter]?.rooms || 0),
                                      0,
                                    );
                                    const segRev = activeMonthRows.reduce(
                                      (a, r) =>
                                        a + (r.segs[segFilter]?.rev || 0),
                                      0,
                                    );
                                    return (
                                      <>
                                        <td className="boldTd">
                                          {(() => {
                                            const ov =
                                              totalOverrides[activeMonth] || {};
                                            const field = `seg_${segFilter}_rooms`;
                                            const val =
                                              ov[field] !== undefined
                                                ? ov[field]
                                                : Math.round(segRms);
                                            return (
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "60px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov[field] !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={val}
                                                onChange={(e) =>
                                                  handleTotalEdit(
                                                    activeMonth,
                                                    field,
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            );
                                          })()}
                                        </td>
                                        <td className="boldTd text-right">
                                          {(() => {
                                            const ov =
                                              totalOverrides[activeMonth] || {};
                                            const field = `seg_${segFilter}_rev`;
                                            const val =
                                              ov[field] !== undefined
                                                ? ov[field]
                                                : Math.round(segRev);
                                            return (
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "70px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov[field] !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={val}
                                                onChange={(e) =>
                                                  handleTotalEdit(
                                                    activeMonth,
                                                    field,
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            );
                                          })()}
                                        </td>
                                        <td className="boldTd seg-last-col text-right">
                                          {(() => {
                                            const ov =
                                              totalOverrides[activeMonth] || {};
                                            const field = `seg_${segFilter}_adr`;
                                            const segAdr =
                                              segRms > 0 ? segRev / segRms : 0;
                                            const val =
                                              ov[field] !== undefined
                                                ? ov[field]
                                                : Number(segAdr.toFixed(2));
                                            return (
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "60px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov[field] !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={val}
                                                onChange={(e) =>
                                                  handleTotalEdit(
                                                    activeMonth,
                                                    field,
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            );
                                          })()}
                                        </td>
                                      </>
                                    );
                                  })()
                                )}
                              </tr>
                              {activeMonthRows.map((r, dayIdx) => {
                                const lyDay = showLY
                                  ? getLYDay(activeMonth, r.day)
                                  : null;
                                const wkndCls = r.wknd ? "weekend" : "";
                                const itemDate = new Date(
                                  year,
                                  activeMonth,
                                  r.day,
                                );
                                const checkEvent = eventListRef.current?.filter(
                                  (x) => {
                                    let dateStr =
                                      commonService.getDateInFormat(itemDate);
                                    return (
                                      dateStr >=
                                        commonService.getDateInFormat(
                                          x.startDate,
                                        ) &&
                                      dateStr <=
                                        commonService.getDateInFormat(x.endDate)
                                    );
                                  },
                                );
                                let lyCheckEvent = [];
                                if (lyDay?.lyDates?.length > 0) {
                                  lyCheckEvent = eventListRef.current?.filter(
                                    (x) => {
                                      return lyDay.lyDates.some((lyDate) => {
                                        // If lyDate is "YYYY-MM-DD", Moment(lyDate) parses it properly without timezone shifts
                                        let localDateObj = moment(
                                          lyDate,
                                          "YYYY-MM-DD",
                                        ).toDate();
                                        let dateStr =
                                          commonService.getDateInFormat(
                                            localDateObj,
                                          );
                                        return (
                                          dateStr >=
                                            commonService.getDateInFormat(
                                              x.startDate,
                                            ) &&
                                          dateStr <=
                                            commonService.getDateInFormat(
                                              x.endDate,
                                            )
                                        );
                                      });
                                    },
                                  );
                                }
                                return (
                                  <tr key={dayIdx} className={wkndCls}>
                                    <td
                                      className={`${r.wknd ? "weekend-flag" : ""} td-dow`}
                                    >
                                      {moment(itemDate).format("MM/DD/YYYY")}
                                    </td>
                                    <td
                                      className={`${r.wknd ? "weekend-flag" : ""} td-dow`}
                                    >
                                      {DOW_LABELS[r.dow]}
                                    </td>
                                    <td
                                      className={`${r.wknd ? "weekend-flag" : ""} td-dow border_right`}
                                    >
                                      <div className="d-flex justify-content-center align-items-center ticketAlarmReload">
                                        {checkEvent?.length > 0 && (
                                          <img
                                            style={{
                                              height: "11px",
                                              width: "11px",
                                              cursor: "pointer",
                                            }}
                                            className="iconcolor"
                                            src={ticket}
                                            alt="ticket"
                                            id={commonService.generateGlobalClickTrackerID(
                                              "BudgetSimulator",
                                              "checkEventIcon",
                                              commonService.getDateInFormat(
                                                itemDate,
                                              ),
                                            )}
                                            onClick={() => {
                                              selectedEventDateRef.current =
                                                itemDate;
                                              eventListPropsRef.current =
                                                checkEvent;
                                              setShowTicketModal(true);
                                            }}
                                          />
                                        )}
                                      </div>
                                    </td>
                                    <td className="val-rooms">
                                      {(() => {
                                        const ov =
                                          dayOverrides[activeMonth]?.[r.day] ||
                                          {};
                                        const valRooms =
                                          ov.paidRooms !== undefined
                                            ? ov.paidRooms
                                            : Math.round(r.paidRooms);
                                        return (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm text-center override-input"
                                            style={{
                                              width: "60px",
                                              padding: "2px",
                                              height: "24px",
                                              fontSize: "11px",
                                              display: "inline-block",
                                              backgroundColor:
                                                ov.paidRooms !== undefined
                                                  ? "#fef3c7"
                                                  : "white",
                                            }}
                                            value={valRooms}
                                            onChange={(e) =>
                                              handleDayEdit(
                                                activeMonth,
                                                r.day,
                                                "paidRooms",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        );
                                      })()}
                                    </td>
                                    <td className="val-occ">
                                      {(() => {
                                        const ov =
                                          dayOverrides[activeMonth]?.[r.day] ||
                                          {};
                                        const valOcc =
                                          ov.occ !== undefined
                                            ? ov.occ
                                            : Number(r.occ.toFixed(1));
                                        return (
                                          <div className="d-flex align-items-center justify-content-center">
                                            <input
                                              type="number"
                                              className="form-control form-control-sm text-center override-input"
                                              style={{
                                                width: "60px",
                                                padding: "2px",
                                                height: "24px",
                                                fontSize: "11px",
                                                display: "inline-block",
                                                backgroundColor:
                                                  ov.occ !== undefined
                                                    ? "#fef3c7"
                                                    : "white",
                                              }}
                                              value={valOcc}
                                              onChange={(e) =>
                                                handleDayEdit(
                                                  activeMonth,
                                                  r.day,
                                                  "occ",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                        );
                                      })()}
                                    </td>
                                    {viewMode !== "rooms_only" && (
                                      <>
                                        <td className="val-rev text-right">
                                          {(() => {
                                            const ov =
                                              dayOverrides[activeMonth]?.[
                                                r.day
                                              ] || {};
                                            const valRev =
                                              ov.rev !== undefined
                                                ? ov.rev
                                                : Math.round(r.rev);
                                            return (
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "70px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov.rev !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={valRev}
                                                onChange={(e) =>
                                                  handleDayEdit(
                                                    activeMonth,
                                                    r.day,
                                                    "rev",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            );
                                          })()}
                                        </td>
                                        <td className="val-adr text-right border_right">
                                          {(() => {
                                            const ov =
                                              dayOverrides[activeMonth]?.[
                                                r.day
                                              ] || {};
                                            const valAdr =
                                              ov.adr !== undefined
                                                ? ov.adr
                                                : Number(r.adr.toFixed(2));
                                            return (
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "60px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov.adr !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={valAdr}
                                                onChange={(e) =>
                                                  handleDayEdit(
                                                    activeMonth,
                                                    r.day,
                                                    "adr",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            );
                                          })()}
                                        </td>
                                      </>
                                    )}
                                    {showLY &&
                                      (lyDay ? (
                                        <>
                                          <td>
                                            <div className="d-flex justify-content-center align-items-center ticketAlarmReload">
                                              {lyCheckEvent?.length > 0 && (
                                                <img
                                                  style={{
                                                    height: "11px",
                                                    width: "11px",
                                                    cursor: "pointer",
                                                  }}
                                                  className="iconcolor"
                                                  src={ticket}
                                                  alt="ticket"
                                                  id={commonService.generateGlobalClickTrackerID(
                                                    "BudgetSimulator",
                                                    "checkEventIcon",
                                                    commonService.getDateInFormat(
                                                      itemDate,
                                                    ),
                                                  )}
                                                  onClick={() => {
                                                    // Parse it explicitly in local timezone to avoid UTC shift
                                                    selectedEventDateRef.current =
                                                      lyDay?.lyDates?.[0]
                                                        ? moment(
                                                            lyDay.lyDates[0],
                                                            "YYYY-MM-DD",
                                                          ).toDate()
                                                        : itemDate;
                                                    eventListPropsRef.current =
                                                      lyCheckEvent;
                                                    setShowTicketModal(true);
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </td>
                                          <td className="val-ly">
                                            {fmtNum(lyDay.rooms)}
                                          </td>
                                          <td className="val-ly text-right">
                                            {fmtDollar(lyDay.adr, 2)}
                                          </td>
                                          {viewMode !== "rooms_only" && (
                                            <td className="val-ly text-right border_right">
                                              {fmtDollar(lyDay.rev, 0)}
                                            </td>
                                          )}
                                          {/* Variance */}
                                          <td
                                            className={
                                              r.paidRooms - lyDay.rooms > 0
                                                ? "val-var-pos"
                                                : r.paidRooms - lyDay.rooms < 0
                                                  ? "val-var-neg"
                                                  : "val-var-neu"
                                            }
                                          >
                                            {r.paidRooms - lyDay.rooms > 0
                                              ? "+"
                                              : ""}
                                            {fmtNum(r.paidRooms - lyDay.rooms)}
                                          </td>
                                          <td
                                            className={`${r.adr - lyDay.adr > 0 ? "val-var-pos" : r.adr - lyDay.adr < 0 ? "val-var-neg" : "val-var-neu"} text-right`}
                                          >
                                            {r.adr - lyDay.adr > 0 ? "+" : ""}
                                            {fmtDollar(r.adr - lyDay.adr, 2)}
                                          </td>
                                          {viewMode !== "rooms_only" && (
                                            <td
                                              className={`${r.rev - lyDay.rev > 0 ? "val-var-pos" : r.rev - lyDay.rev < 0 ? "val-var-neg" : "val-var-neu"} text-right border_right`}
                                            >
                                              {r.rev - lyDay.rev > 0 ? "+" : ""}
                                              {fmtDollar(r.rev - lyDay.rev, 0)}
                                            </td>
                                          )}
                                        </>
                                      ) : (
                                        <td
                                          colSpan={
                                            viewMode !== "rooms_only" ? 7 : 4
                                          }
                                          className="td-no-data"
                                        >
                                          no LY data
                                        </td>
                                      ))}
                                    {segFilter === "all" ? (
                                      <>
                                        {sortedSegments.map((s) => {
                                          const baseRooms = Math.round(
                                            r.segs[s.key]?.rooms || 0,
                                          );
                                          const baseRev = Math.round(
                                            r.segs[s.key]?.rev || 0,
                                          );
                                          const baseAdr =
                                            r.segs[s.key]?.adr || 0;
                                          const ov =
                                            segmentOverrides[activeMonth]?.[
                                              r.day
                                            ]?.[s.key] || {};

                                          const valRooms =
                                            ov.rooms !== undefined
                                              ? ov.rooms
                                              : baseRooms;
                                          const valRev =
                                            ov.rev !== undefined
                                              ? ov.rev
                                              : baseRev;
                                          const valAdr =
                                            ov.adr !== undefined
                                              ? ov.adr
                                              : Number(baseAdr.toFixed(2));

                                          return (
                                            <React.Fragment key={s.key}>
                                              {viewMode !== "revenue_only" && (
                                                <td
                                                  className={`seg-${s.key} val-rooms ${viewMode === "rooms_only" ? "seg-last-col border_right" : ""}`}
                                                >
                                                  <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center override-input"
                                                    style={{
                                                      width: "60px",
                                                      padding: "2px",
                                                      height: "24px",
                                                      fontSize: "11px",
                                                      display: "inline-block",
                                                      backgroundColor:
                                                        ov.rooms !== undefined
                                                          ? "#fef3c7"
                                                          : "white",
                                                    }}
                                                    value={valRooms}
                                                    onChange={(e) =>
                                                      handleSegmentEdit(
                                                        activeMonth,
                                                        r.day,
                                                        s.key,
                                                        "rooms",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                </td>
                                              )}
                                              {viewMode !== "rooms_only" && (
                                                <td
                                                  className={`seg-${s.key} val-rev text-right ${viewMode !== "adr" ? "seg-last-col border_right" : ""}`}
                                                >
                                                  <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center override-input"
                                                    style={{
                                                      width: "70px",
                                                      padding: "2px",
                                                      height: "24px",
                                                      fontSize: "11px",
                                                      display: "inline-block",
                                                      backgroundColor:
                                                        ov.rev !== undefined
                                                          ? "#fef3c7"
                                                          : "white",
                                                    }}
                                                    value={valRev}
                                                    onChange={(e) =>
                                                      handleSegmentEdit(
                                                        activeMonth,
                                                        r.day,
                                                        s.key,
                                                        "rev",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                </td>
                                              )}
                                              {viewMode === "adr" && (
                                                <td
                                                  className={`seg-${s.key} val-adr text-right seg-last-col`}
                                                >
                                                  <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center override-input"
                                                    style={{
                                                      width: "65px",
                                                      padding: "2px",
                                                      height: "24px",
                                                      fontSize: "11px",
                                                      display: "inline-block",
                                                      backgroundColor:
                                                        ov.adr !== undefined
                                                          ? "#fef3c7"
                                                          : "white",
                                                    }}
                                                    value={valAdr}
                                                    step="0.01"
                                                    onChange={(e) =>
                                                      handleSegmentEdit(
                                                        activeMonth,
                                                        r.day,
                                                        s.key,
                                                        "adr",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                </td>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      (() => {
                                        const sKey = segFilter;
                                        const baseRooms = Math.round(
                                          r.segs[sKey]?.rooms || 0,
                                        );
                                        const baseRev = Math.round(
                                          r.segs[sKey]?.rev || 0,
                                        );
                                        const baseAdr = r.segs[sKey]?.adr || 0;
                                        const ov =
                                          segmentOverrides[activeMonth]?.[
                                            r.day
                                          ]?.[sKey] || {};

                                        const valRooms =
                                          ov.rooms !== undefined
                                            ? ov.rooms
                                            : baseRooms;
                                        const valRev =
                                          ov.rev !== undefined
                                            ? ov.rev
                                            : baseRev;
                                        const valAdr =
                                          ov.adr !== undefined
                                            ? ov.adr
                                            : Number(baseAdr.toFixed(2));

                                        return (
                                          <>
                                            <td className="val-rooms">
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "60px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov.rooms !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={valRooms}
                                                onChange={(e) =>
                                                  handleSegmentEdit(
                                                    activeMonth,
                                                    r.day,
                                                    sKey,
                                                    "rooms",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>
                                            <td className="val-rev text-right">
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "70px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov.rev !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={valRev}
                                                onChange={(e) =>
                                                  handleSegmentEdit(
                                                    activeMonth,
                                                    r.day,
                                                    sKey,
                                                    "rev",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>
                                            <td className="val-adr text-right seg-last-col">
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "65px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov.adr !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={valAdr}
                                                step="0.01"
                                                onChange={(e) =>
                                                  handleSegmentEdit(
                                                    activeMonth,
                                                    r.day,
                                                    sKey,
                                                    "adr",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>
                                          </>
                                        );
                                      })()
                                    )}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* RIGHT PANEL (Assumptions & Summary) */}
                  <div className="right-panel">
                    <div className="rp-section">
                      <div className="rp-title">Budget Assumptions</div>

                      {/* SCENARIO SELECTOR */}
                      <div className="rp-group-label rp-quick-scenario-label">
                        Quick Scenarios
                      </div>
                      <div className="input-row rp-quick-scenario-row">
                        <select
                          className="input-field"
                          defaultValue="base"
                          onChange={(e) => applyScenario(e.target.value)}
                        >
                          <option value="conservative">
                            Conservative Scenario
                          </option>
                          <option value="base">Base Scenario</option>
                          <option value="aggressive">
                            Aggressive Scenario
                          </option>
                        </select>
                      </div>

                      <div className="rp-group-label"> Rate Strategy</div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Published Best Available Rate — anchor for all segment pricing"
                        >
                          BAR / Base ADR ({currencySign})
                        </span>
                        <input
                          className="form-control text-center p-1"
                          type="number"
                          value={baseADR}
                          min={50}
                          max={500}
                          onChange={(e) =>
                            setBaseADR(parseFloat(e.target.value) || 0)
                          }
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="YoY ADR increase assumption based on market outlook & comp set"
                        >
                          ADR Growth YoY %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={adrGrowth}
                          step={0.5}
                          onChange={(e) =>
                            setAdrGrowth(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Negotiated corporate rate as % discount off BAR (LNR accounts)"
                        >
                          Corp Rate vs BAR %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={corpDisc}
                          min={50}
                          max={100}
                          step={1}
                          onChange={(e) =>
                            setCorpDisc(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Group contracted rate as % of BAR — includes F&B concessions"
                        >
                          Group Rate vs BAR %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={grpDisc}
                          min={50}
                          max={100}
                          step={1}
                          onChange={(e) =>
                            setGrpDisc(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Government per diem rate (GSA). Chicago 2026 ~$136/night"
                        >
                          Govt / GSA Rate ({currencySign})
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={govtRate}
                          min={50}
                          max={300}
                          step={1}
                          onChange={(e) =>
                            setGovtRate(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Fri–Sat premium applied to BAR for leisure demand lift"
                        >
                          Weekend Premium %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={wkndPct}
                          min={0}
                          max={50}
                          onChange={(e) =>
                            setWkndPct(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                    </div>

                    <div className="rp-section">
                      <div className="rp-group-label">
                        Occupancy & Inventory
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Annual blended occupancy budget target"
                        >
                          Occ Target %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={occTarget}
                          min={10}
                          max={99}
                          onChange={(e) =>
                            setOccTarget(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="YoY demand growth assumption — applied on top of occ target"
                        >
                          Demand Growth YoY %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={demandGrowth}
                          step={0.5}
                          onChange={(e) =>
                            setDemandGrowth(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Max sellable occupancy ceiling — leaves room for OOO & holds"
                        >
                          Max Sell Cap %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={maxSell}
                          min={80}
                          max={100}
                          step={0.5}
                          onChange={(e) =>
                            setMaxSell(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Out-of-Order rooms removed from available inventory daily"
                        >
                          OOO Rooms / Night
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={oooRooms}
                          min={0}
                          max={20}
                          onChange={(e) =>
                            setOooRooms(parseInt(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Complimentary / house-use rooms (VIP, staff, rewards) — sold but zero revenue"
                        >
                          Comp Rooms / Night
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={compRooms}
                          min={0}
                          max={20}
                          onChange={(e) =>
                            setCompRooms(parseInt(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Group block as % of total inventory — rooms held for group pickup"
                        >
                          Group Block %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={grpBlock}
                          min={0}
                          max={60}
                          step={1}
                          onChange={(e) =>
                            setGrpBlock(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Expected group wash — % of blocked rooms that will NOT pick up"
                        >
                          Group Wash %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={grpWash}
                          min={0}
                          max={60}
                          step={1}
                          onChange={(e) =>
                            setGrpWash(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                    </div>

                    <div className="rp-section">
                      <div className="rp-group-label"> Ancillary Revenue</div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="F&B revenue per occupied room night (outlet + banquet + IRD)"
                        >
                          F&B / Occ Room ({currencySign})
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={fnbPerRoom}
                          min={0}
                          max={200}
                          step={1}
                          onChange={(e) =>
                            setFnbPerRoom(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Meeting / event room rental revenue per occupied room (Group-heavy)"
                        >
                          Meeting Rev / Rm ({currencySign})
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={mtgRevPerRoom}
                          min={0}
                          max={100}
                          step={1}
                          onChange={(e) =>
                            setMtgRevPerRoom(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Parking, laundry, retail, sundry per occupied room"
                        >
                          Other Rev / Rm ({currencySign})
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={otherRev}
                          min={0}
                          max={100}
                          step={1}
                          onChange={(e) =>
                            setOtherRev(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                    </div>

                    <div className="rp-section">
                      <div className="rp-group-label">Cost of Distribution</div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="OTA net rate commission — Expedia ~18%, Booking.com ~15%"
                        >
                          OTA Commission %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={otaComm}
                          min={0}
                          max={30}
                          step={0.5}
                          onChange={(e) =>
                            setOtaComm(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="GDS / CRS / IBE booking engine transaction fee as % of room rev"
                        >
                          GDS / CRS Fee %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={channel}
                          min={0}
                          max={8}
                          step={0.1}
                          onChange={(e) =>
                            setChannel(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Hyatt brand franchise royalty fee — typically 5–6% of room revenue"
                        >
                          Franchise Fee %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={franchise}
                          min={0}
                          max={12}
                          step={0.1}
                          onChange={(e) =>
                            setFranchise(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="World of Hyatt loyalty points cost as % of room revenue"
                        >
                          Loyalty Cost %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={loyalty}
                          min={0}
                          max={8}
                          step={0.1}
                          onChange={(e) =>
                            setLoyalty(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <span
                          className="input-label"
                          title="Chicago metro hotel occupancy tax (informational — not deducted from rev)"
                        >
                          Occ Tax Rate %
                        </span>
                        <input
                          className="form-control text-center p-1"
                          style={{
                            width: "60px",
                            height: "28px",
                            fontSize: "13px",
                            color: "#1E293B",
                            borderRadius: "4px",
                            border: "1px solid #A5B4FC",
                          }}
                          type="number"
                          value={taxRate}
                          min={0}
                          max={30}
                          step={0.1}
                          onChange={(e) =>
                            setTaxRate(parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                    </div>

                    <div className="rp-section">
                      <div className="rp-group-label">Segment Mix Targets</div>
                      {segments.map((s) => (
                        <div
                          key={s.key}
                          className="d-flex justify-content-between align-items-center pb-2"
                        >
                          <span className="input-label">{s.label} %</span>
                          <input
                            className="form-control text-center p-1"
                            style={{
                              width: "60px",
                              height: "28px",
                              fontSize: "13px",
                              color: "#1E293B",
                              borderRadius: "4px",
                              border: "1px solid #A5B4FC",
                            }}
                            type="number"
                            value={mix[s.key] !== undefined ? mix[s.key] : 0}
                            min={0}
                            max={100}
                            onChange={(e) =>
                              handleMixChange(s.key, e.target.value)
                            }
                          />
                        </div>
                      ))}
                    </div>

                    {/* <div className="rp-section">
                      <div className="rp-title">Month P&L Summary</div>
                      <div>
                        <div className="rp-group-title">Inventory</div>
                        <div className="rp-row">
                          <span className="rp-row-label">Avail Rooms</span>
                          <span className="rp-row-val">
                            {fmtNum(activeMonthAvail)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">Occupied</span>
                          <span className="rp-row-val">
                            {fmtNum(activeMonthRooms)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label rp-row-label-indent">
                            Paid Rooms
                          </span>
                          <span className="rp-row-val">
                            {fmtNum(activeMonthPaidRooms)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label rp-row-label-indent">
                            Comp Rooms
                          </span>
                          <span className="rp-row-val">
                            {fmtNum(activeMonthCompRooms)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">Occ %</span>
                          <span className="rp-row-val">
                            {fmtPct(activeMonthOcc)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">Grp Pickup</span>
                          <span className="rp-row-val">
                            {fmtNum(activeMonthGrpPickup)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label rp-row-label-indent">
                            Grp Wash
                          </span>
                          <span className="rp-row-val neg">
                            ({fmtNum(activeMonthGrpWashRooms)})
                          </span>
                        </div>

                        <div className="rp-group-title">Rate</div>
                        <div className="rp-row">
                          <span className="rp-row-label">Blended ADR</span>
                          <span className="rp-row-val">
                            {fmtDollar(activeMonthADR, 2)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">RevPAR</span>
                          <span className="rp-row-val">
                            {fmtDollar(activeMonthRevPAR, 2)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">TRevPAR</span>
                          <span className="rp-row-val pos">
                            {fmtDollar(activeMonthTRevPAR, 2)}
                          </span>
                        </div>

                        <div className="rp-group-title">Room Revenue</div>
                        <div className="rp-row">
                          <span className="rp-row-label">Gross Room Rev</span>
                          <span className="rp-row-val">
                            {fmtDollar(activeMonthGrossRev, 0)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label rp-row-label-indent">
                            OTA Commission
                          </span>
                          <span className="rp-row-val neg">
                            ({fmtDollar(activeMonthOtaCommAmt, 0)})
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label rp-row-label-indent">
                            GDS / CRS Fee
                          </span>
                          <span className="rp-row-val neg">
                            ({fmtDollar(activeMonthGdsFee, 0)})
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label rp-row-label-indent">
                            Franchise Fee
                          </span>
                          <span className="rp-row-val neg">
                            ({fmtDollar(activeMonthFranchiseFee, 0)})
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label rp-row-label-indent">
                            Loyalty Cost
                          </span>
                          <span className="rp-row-val neg">
                            ({fmtDollar(activeMonthLoyaltyFee, 0)})
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">Net Room Rev</span>
                          <span className="rp-row-val pos">
                            {fmtDollar(activeMonthNetRoomRev, 0)}
                          </span>
                        </div>

                        <div className="rp-group-title">Ancillary Revenue</div>
                        <div className="rp-row">
                          <span className="rp-row-label">F&B Revenue</span>
                          <span className="rp-row-val">
                            {fmtDollar(activeMonthFnbRev, 0)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">Meeting / Events</span>
                          <span className="rp-row-val">
                            {fmtDollar(activeMonthMtgRev, 0)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">Other Revenue</span>
                          <span className="rp-row-val">
                            {fmtDollar(activeMonthOtherRevAmt, 0)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">Total Ancillary</span>
                          <span className="rp-row-val pos">
                            {fmtDollar(activeMonthTotalAncillary, 0)}
                          </span>
                        </div>

                        <div className="rp-group-title">Bottom Line</div>
                        <div className="rp-row">
                          <span className="rp-row-label">
                            Total Net Revenue
                          </span>
                          <span className="rp-row-val pos">
                            {fmtDollar(activeMonthTotalRev, 0)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">Tax Collected</span>
                          <span className="rp-row-val">
                            {fmtDollar(activeMonthTaxAmt, 0)}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="rp-section">
                      <div className="rp-title">YTD Totals</div>
                      <div>
                        <div className="rp-row">
                          <span className="rp-row-label">Paid Rooms</span>
                          <span className="rp-row-val">{fmtNum(ytdPaid)}</span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">Occ %</span>
                          <span className="rp-row-val">{fmtPct(ytdOcc)}</span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">ADR</span>
                          <span className="rp-row-val">
                            {fmtDollar(ytdADR, 2)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">RevPAR</span>
                          <span className="rp-row-val">
                            {fmtDollar(ytdRevPAR, 2)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">TRevPAR</span>
                          <span className="rp-row-val">
                            {fmtDollar(ytdTRevPAR, 2)}
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">Gross Room Rev</span>
                          <span className="rp-row-val">
                            {fmtDollar(ytdGross / 1000, 1)}K
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">Dist Cost</span>
                          <span className="rp-row-val neg">
                            ({fmtDollar(ytdDist / 1000, 1)}K)
                          </span>
                        </div>
                        <div className="rp-row">
                          <span className="rp-row-label">Total Net Rev</span>
                          <span className="rp-row-val pos">
                            {fmtDollar(ytdNet / 1000, 1)}K
                          </span>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            )}

            {activeMainTab === "summary" && (
              <div className="content tab-pane-summary w-100">
                {/* MAIN LAYOUT */}
                <div className="" style={{ gap: "24px" }}>
                  {/* SEGMENT SUMMARY CARDS */}
                  <div
                    className="seg-summary-wrapper"
                    style={{ width: "100%" }}
                  >
                    {/* <div className="seg-summary-title" style={{ fontWeight: 'bold', color: '#1E293B', fontSize: '14px', letterSpacing: '0.5px', marginBottom: '16px', borderBottom: '3px solid #3B82F6', display: 'inline-block', paddingBottom: '4px' }}>
                  SEGMENT SUMMARY —{" "}
                  <span className="text-uppercase">
                    {MONTHS[activeMonth]} {year}
                  </span>
                </div> */}
                    <div
                      className="seg-cards"
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(120px, 1fr))",
                        gap: "12px",
                      }}
                    >
                      {segmentCardData.map((s) => (
                        <div
                          key={s.key}
                          className="seg-card shadow-sm"
                          style={{
                            backgroundColor: "#FFFFFF",
                            border: "1px solid #E2E8F0",
                            borderTop: `4px solid ${s.color}`,
                            borderRadius: "8px",
                            padding: "12px",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            className="seg-card-name text-uppercase"
                            style={{
                              color: s.color,
                              fontSize: "10px",
                              fontWeight: "700",
                              letterSpacing: "0.5px",
                              marginBottom: "6px",
                            }}
                          >
                            {s.label}
                          </div>
                          <div
                            className="seg-card-rooms"
                            style={{
                              color: s.color,
                              fontSize: "24px",
                              fontWeight: "bold",
                              lineHeight: "1",
                              marginBottom: "8px",
                            }}
                          >
                            {fmtNum(s.rooms)}
                          </div>
                          <div
                            className="seg-card-rev"
                            style={{
                              fontSize: "11px",
                              color: "#64748B",
                              fontWeight: "500",
                              marginBottom: "2px",
                            }}
                          >
                            {fmtDollar(s.rev / 1000, 1)}K
                          </div>
                          <div
                            className="seg-card-adr"
                            style={{
                              fontSize: "11px",
                              color: "#64748B",
                              fontWeight: "500",
                            }}
                          >
                            {fmtDollar(s.adr, 2)} ADR
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="budget-simulator-month-ytd-grid">
                    <div className="chart-card shadow-sm budget-simulator-summary-card">
                      <div className="rp-section mb-0">
                        <div
                          className="rp-title"
                          style={{ marginBottom: "10px" }}
                        >
                          Month P&L Summary
                        </div>
                        <div className="budget-simulator-month-pl-subgrid">
                          <div className="budget-simulator-inner-card">
                            <div className="rp-group-title">Inventory</div>
                            <div className="rp-row">
                              <span className="rp-row-label">Avail Rooms</span>
                              <span className="rp-row-val">
                                {fmtNum(activeMonthAvail)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label">Occupied</span>
                              <span className="rp-row-val">
                                {fmtNum(activeMonthRooms)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label rp-row-label-indent">
                                Paid Rooms
                              </span>
                              <span className="rp-row-val">
                                {fmtNum(activeMonthPaidRooms)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label rp-row-label-indent">
                                Comp Rooms
                              </span>
                              <span className="rp-row-val">
                                {fmtNum(activeMonthCompRooms)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label">Occ %</span>
                              <span className="rp-row-val">
                                {fmtPct(activeMonthOcc)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label">Grp Pickup</span>
                              <span className="rp-row-val">
                                {fmtNum(activeMonthGrpPickup)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label rp-row-label-indent">
                                Grp Wash
                              </span>
                              <span className="rp-row-val neg">
                                ({fmtNum(activeMonthGrpWashRooms)})
                              </span>
                            </div>
                          </div>

                          <div className="budget-simulator-inner-card">
                            <div className="rp-group-title">Room Revenue</div>
                            <div className="rp-row">
                              <span className="rp-row-label">
                                Gross Room Rev
                              </span>
                              <span className="rp-row-val">
                                {fmtDollar(activeMonthGrossRev, 0)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label rp-row-label-indent">
                                OTA Commission
                              </span>
                              <span className="rp-row-val neg">
                                ({fmtDollar(activeMonthOtaCommAmt, 0)})
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label rp-row-label-indent">
                                GDS / CRS Fee
                              </span>
                              <span className="rp-row-val neg">
                                ({fmtDollar(activeMonthGdsFee, 0)})
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label rp-row-label-indent">
                                Franchise Fee
                              </span>
                              <span className="rp-row-val neg">
                                ({fmtDollar(activeMonthFranchiseFee, 0)})
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label rp-row-label-indent">
                                Loyalty Cost
                              </span>
                              <span className="rp-row-val neg">
                                ({fmtDollar(activeMonthLoyaltyFee, 0)})
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label">Net Room Rev</span>
                              <span className="rp-row-val pos">
                                {fmtDollar(activeMonthNetRoomRev, 0)}
                              </span>
                            </div>
                          </div>

                          <div className="budget-simulator-inner-card">
                            <div className="rp-group-title">
                              Ancillary Revenue
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label">F&B Revenue</span>
                              <span className="rp-row-val">
                                {fmtDollar(activeMonthFnbRev, 0)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label">
                                Meeting / Events
                              </span>
                              <span className="rp-row-val">
                                {fmtDollar(activeMonthMtgRev, 0)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label">
                                Other Revenue
                              </span>
                              <span className="rp-row-val">
                                {fmtDollar(activeMonthOtherRevAmt, 0)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label">
                                Total Ancillary
                              </span>
                              <span className="rp-row-val pos">
                                {fmtDollar(activeMonthTotalAncillary, 0)}
                              </span>
                            </div>
                          </div>

                          <div className="budget-simulator-inner-card">
                            <div className="rp-group-title">Rate</div>
                            <div className="rp-row">
                              <span className="rp-row-label">Blended ADR</span>
                              <span className="rp-row-val">
                                {fmtDollar(activeMonthADR, 2)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label">RevPAR</span>
                              <span className="rp-row-val">
                                {fmtDollar(activeMonthRevPAR, 2)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label">TRevPAR</span>
                              <span className="rp-row-val pos">
                                {fmtDollar(activeMonthTRevPAR, 2)}
                              </span>
                            </div>
                          </div>

                          <div className="budget-simulator-inner-card">
                            <div className="rp-group-title">Bottom Line</div>
                            <div className="rp-row">
                              <span className="rp-row-label">
                                Total Net Revenue
                              </span>
                              <span className="rp-row-val pos">
                                {fmtDollar(activeMonthTotalRev, 0)}
                              </span>
                            </div>
                            <div className="rp-row">
                              <span className="rp-row-label">
                                Tax Collected
                              </span>
                              <span className="rp-row-val">
                                {fmtDollar(activeMonthTaxAmt, 0)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="chart-card shadow-sm budget-simulator-summary-card">
                      <div className="rp-section mb-0">
                        <div
                          className="rp-title"
                          style={{ marginBottom: "10px" }}
                        >
                          YTD Totals
                        </div>
                        <div className="budget-simulator-inner-card">
                          <div className="rp-row">
                            <span className="rp-row-label">Paid Rooms</span>
                            <span className="rp-row-val">
                              {fmtNum(ytdPaid)}
                            </span>
                          </div>
                          <div className="rp-row">
                            <span className="rp-row-label">Occ %</span>
                            <span className="rp-row-val">{fmtPct(ytdOcc)}</span>
                          </div>
                          <div className="rp-row">
                            <span className="rp-row-label">ADR</span>
                            <span className="rp-row-val">
                              {fmtDollar(ytdADR, 2)}
                            </span>
                          </div>
                          <div className="rp-row">
                            <span className="rp-row-label">RevPAR</span>
                            <span className="rp-row-val">
                              {fmtDollar(ytdRevPAR, 2)}
                            </span>
                          </div>
                          <div className="rp-row">
                            <span className="rp-row-label">TRevPAR</span>
                            <span className="rp-row-val">
                              {fmtDollar(ytdTRevPAR, 2)}
                            </span>
                          </div>
                          <div className="rp-row">
                            <span className="rp-row-label">Gross Room Rev</span>
                            <span className="rp-row-val">
                              {fmtDollar(ytdGross / 1000, 1)}K
                            </span>
                          </div>
                          <div className="rp-row">
                            <span className="rp-row-label">Dist Cost</span>
                            <span className="rp-row-val neg">
                              ({fmtDollar(ytdDist / 1000, 1)}K)
                            </span>
                          </div>
                          <div className="rp-row">
                            <span className="rp-row-label">Total Net Rev</span>
                            <span className="rp-row-val pos">
                              {fmtDollar(ytdNet / 1000, 1)}K
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* CHARTS CONTAINER */}
                  <div
                    className="mt-3"
                    style={{ display: "flex", gap: "16px", width: "100%" }}
                  >
                    <div
                      className="chart-card shadow-sm"
                      style={{
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #E2E8F0",
                        borderRadius: "8px",
                        padding: "16px",
                        flex: "1",
                      }}
                    >
                      <div
                        className="chart-title"
                        style={{
                          fontSize: "14px",
                          fontWeight: "700",
                          color: "#1E293B",
                          marginBottom: "12px",
                        }}
                      >
                        Daily Rooms by Segment
                      </div>
                      <div
                        className="legend"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                          marginBottom: "16px",
                        }}
                      >
                        {sortedSegments.map((s) => {
                          const isHidden = !!hiddenSegments[s.key];
                          return (
                            <div
                              key={s.key}
                              className="legend-item"
                              onClick={() => toggleSegment(s.key)}
                              style={{
                                cursor: "pointer",
                                textDecoration: isHidden
                                  ? "line-through"
                                  : "none",
                                opacity: isHidden ? 0.4 : 1,
                                display: "flex",
                                alignItems: "center",
                                fontSize: "9px",
                                color: "#64748B",
                                fontWeight: "600",
                                textTransform: "uppercase",
                              }}
                            >
                              <div
                                className="legend-swatch"
                                style={{
                                  backgroundColor: s.color,
                                  width: "10px",
                                  height: "10px",
                                  borderRadius: "2px",
                                  marginRight: "4px",
                                }}
                              ></div>
                              {s.label}
                            </div>
                          );
                        })}
                      </div>
                      <div
                        className="chart-canvas-wrapper"
                        style={{ height: "240px" }}
                      >
                        <Bar data={chart1Data} options={chart1Options} />
                      </div>
                    </div>

                    <div
                      className="chart-card shadow-sm"
                      style={{
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #E2E8F0",
                        borderRadius: "8px",
                        padding: "16px",
                        flex: "1",
                      }}
                    >
                      <div
                        className="chart-title"
                        style={{
                          fontSize: "14px",
                          fontWeight: "700",
                          color: "#1E293B",
                          marginBottom: "12px",
                        }}
                      >
                        Daily Revenue by Segment
                      </div>
                      <div
                        className="legend"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                          marginBottom: "16px",
                        }}
                      >
                        {sortedSegments.map((s) => {
                          const isHidden = !!hiddenSegments2[s.key];
                          return (
                            <div
                              key={s.key}
                              className="legend-item"
                              onClick={() => toggleSegment2(s.key)}
                              style={{
                                cursor: "pointer",
                                textDecoration: isHidden
                                  ? "line-through"
                                  : "none",
                                opacity: isHidden ? 0.4 : 1,
                                display: "flex",
                                alignItems: "center",
                                fontSize: "9px",
                                color: "#64748B",
                                fontWeight: "600",
                                textTransform: "uppercase",
                              }}
                            >
                              <div
                                className="legend-swatch"
                                style={{
                                  backgroundColor: s.color,
                                  width: "10px",
                                  height: "10px",
                                  borderRadius: "2px",
                                  marginRight: "4px",
                                }}
                              ></div>
                              {s.label}
                            </div>
                          );
                        })}
                      </div>
                      <div
                        className="chart-canvas-wrapper"
                        style={{ height: "240px" }}
                      >
                        <Bar data={chart2Data} options={chart2Options} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {showTicketModal && (
        <EventViewModal
          showModal={showTicketModal}
          closeModal={closeTicketModal}
          eventDetails={eventListPropsRef.current}
          selectedDate={selectedEventDateRef.current}
          getEventList={getEventList}
        />
      )}
    </div>
      ) : (
        <div className="d-flex justify-content-center p-5">
          <h5>Please Select Property</h5>
        </div>
      )}
    </>
  );
};

export default BudgetSimulator;
